var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignin1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-43",
    d: "M77.66,248.63c-95.18,55-95.17,144.05,0,199s249.49,54.95,344.67,0,95.17-144,0-199S172.84,193.68,77.66,248.63Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-43"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "160.24 124.45 161.95 125.47 197.03 105.21 195.32 104.19 160.24 124.45",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.32 104.19 161.95 123.46 161.95 88.5 195.32 69.25 195.32 104.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.26,62.66l-41.54,24v44.41l41.54-24ZM197,105.21,162,125.47v-37L197,68.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.03 105.21 195.32 104.19 195.32 69.25 197.03 68.25 197.03 105.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.26 62.66 198.52 61.67 156.98 85.65 158.72 86.64 200.26 62.66",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.98 85.65 158.72 86.64 158.72 131.06 156.98 130.06 156.98 85.65",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-43"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "194.02 103.14 163.25 120.91 163.25 112.03 170.94 94.26 175.74 98.7 174.01 106.15 184.64 83.43 194.02 94.26 194.02 103.14",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.45,85.68a5,5,0,0,0-2.28,3.95c0,1.45,1,2,2.28,1.31A5,5,0,0,0,177.72,87C177.72,85.55,176.7,85,175.45,85.68Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-43"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "215.26 92.67 216.97 93.69 252.06 73.43 250.35 72.41 215.26 92.67",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.35 72.41 216.97 91.67 216.97 56.72 250.35 37.47 250.35 72.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.29,30.88l-41.54,24V99.27l41.54-24Zm-3.23,42.55L217,93.68v-37l35.09-20.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.06 73.43 250.35 72.41 250.35 37.47 252.06 36.47 252.06 73.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.29 30.88 253.55 29.88 212.01 53.87 213.75 54.86 255.29 30.88",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.01 53.87 213.75 54.86 213.75 99.27 212.01 98.28 212.01 53.87",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-43"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "249.05 71.36 218.28 89.13 218.28 80.25 225.97 62.48 230.76 66.92 229.04 74.37 239.66 51.65 249.05 62.48 249.05 71.36",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.47,53.9a5,5,0,0,0-2.27,3.94c0,1.46,1,2,2.27,1.32a5,5,0,0,0,2.28-3.94C232.75,53.77,231.73,53.18,230.47,53.9Z",
    style: {
      fill: "#f0f0f0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.45,120.93c0-25.69-16.91-56.28-37.78-68.33-11.05-6.38-21-6.28-27.9-1-8.59,3.57-14.09,13.45-14.09,28.09V217.29l75.58,43.64,4.19-2.43Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.26,260.93V123.35c0-25.69-16.92-56.28-37.79-68.33s-37.79-1-37.79,24.7V217.29Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.12,123.35V253.77L403.81,214.9V79.72c0-12.84,4.52-21.69,12.12-24.49a15.63,15.63,0,0,1,5.51-.95c4.3,0,9,1.45,14,4.32C455.1,70,471.12,99,471.12,123.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.81 214.9 408.08 212.44 471.12 248.85 471.12 253.77 403.81 214.9",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.12,123.35v125.5l-63-36.41V77.25c0-10.2,2.87-17.89,7.86-22a15.63,15.63,0,0,1,5.51-.95c4.3,0,9,1.45,14,4.32C455.1,70,471.12,99,471.12,123.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.53 235.53 435.4 233.14 435.4 57.11 439.53 57.11 439.53 235.53",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.67,64.58V233.15l-4.13,2.37V61.28Q441.64,62.8,443.67,64.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.81 185.74 435.4 203.98 435.4 208.83 403.81 190.6 403.81 185.74",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.08 183.28 403.81 185.74 435.4 203.98 435.4 199.13 408.08 183.28",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.53 206.36 471.12 224.6 471.12 229.45 439.53 211.22 439.53 206.36",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.8 203.9 439.53 206.36 471.12 224.6 471.12 219.75 443.8 203.9",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.81 88.92 435.4 107.16 435.4 112.01 403.81 93.78 403.81 88.92",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.08 86.47 403.81 88.92 435.4 107.16 435.4 102.31 408.08 86.47",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.53 109.55 471.12 127.78 471.12 132.63 439.53 114.4 439.53 109.55",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.8 107.08 439.53 109.55 471.12 127.78 471.12 122.94 443.8 107.08",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-43",
    d: "M92.36,442.77a13.67,13.67,0,0,1-2.18,5.08A24.14,24.14,0,0,1,82,455.14c-14.2,8.2-37.24,8.2-51.44,0a24,24,0,0,1-8.21-7.29,13.84,13.84,0,0,1-2.18-5.08h0c-1.26-6.17,2.21-12.59,10.4-17.32,14.2-8.21,37.24-8.21,51.44,0C90.16,430.18,93.63,436.6,92.36,442.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-43",
    d: "M113,456.36l-87-49.71c-1.27-.73-1.27-1.92,0-2.65l277-159.93a5,5,0,0,1,4.59,0l87,49.71c1.27.73,1.27,1.92,0,2.65l-277,159.93A5,5,0,0,1,113,456.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-43",
    d: "M207.8,465.07,193.61,457l66.72-38.84a17.2,17.2,0,0,1-2.45-11.39c.89-6.23,5.35-12,12.57-16.18,7.62-4.44,17.69-6.88,28.34-6.88,10.47,0,20.38,2.37,27.9,6.68,8.28,4.74,12.86,11.31,12.89,18.49s-4.51,13.78-12.75,18.59c-7.62,4.43-17.68,6.88-28.33,6.88h0A65.22,65.22,0,0,1,285.2,433l-12.42,7.23-9.57-2.12-3.28,1.9-.33,7.89-6.16,3.59-8.86.81-3.77,2.12.55,4.1L230.19,465Zm105.94-62.84a12.42,12.42,0,0,0-10.82,0,3.07,3.07,0,0,0-1,.83,3.22,3.22,0,0,0,1,.82,12.51,12.51,0,0,0,10.82,0,3.2,3.2,0,0,0,1-.83A3.35,3.35,0,0,0,313.74,402.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-43",
    cx: 414.73,
    cy: 374.95,
    rx: 57.68,
    ry: 33.3,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Case--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.84,253.59l5.07-2.93s26.91-87.78,29.41-92.86-2-7.69-6.87-4.89L80.87,298.55c-4.85,2.8-6.37,6.65-10.68,15s-28.61,89-28.61,89a4.5,4.5,0,0,0,2.17,4.74l57.51,33.31L365.45,288.11Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.84,253.59l5.07-2.93s26.91-87.78,29.41-92.86-2-7.69-6.87-4.89L80.87,298.55c-4.85,2.8-6.37,6.65-10.68,15s-28.61,89-28.61,89a4.5,4.5,0,0,0,2.17,4.74l57.51,33.31L365.45,288.11Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.36,315.59c-3.27,6.35-28.57,88.72-28.57,88.72L314.11,248.82s26.71-83.72,29.38-89-2-7.68-6.87-4.88L84,300.58C79.19,303.37,76.64,309.25,73.36,315.59Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.36,315.59c-3.27,6.35-28.57,88.72-28.57,88.72L314.11,248.82s26.71-83.72,29.38-89-2-7.68-6.87-4.88L84,300.58C79.19,303.37,76.64,309.25,73.36,315.59Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.98 251.78 44.78 404.31 103.29 438.1 367.49 285.57 308.98 251.78",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.37,59.42,72.84,206.11c-5.58,3.22-7.32,8.44-6.34,15.31L96.62,432.81c1,6.87,6.46,10.89,12,7.67L360.94,294.89c5.58-3.22,9.31-11.41,8.32-18.28L339.26,66C338.28,59.16,333,56.2,327.37,59.42Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.37,59.42,72.84,206.11c-5.58,3.22-7.32,8.44-6.34,15.31L96.62,432.81c1,6.87,6.46,10.89,12,7.67L360.94,294.89c5.58-3.22,9.31-11.41,8.32-18.28L339.26,66C338.28,59.16,333,56.2,327.37,59.42Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.53,63.91a7.85,7.85,0,0,0-6.86.85L85.38,210.36a17,17,0,0,0-6.44,7.39L70.8,214.3c1.79-3.91,4.91-5.34,7.58-6.89L330.66,61.8a7.77,7.77,0,0,1,7.12-.73h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.81,442.61v0c-2.5-1-4.36-3.62-4.9-7.4L70.06,225.68c-.62-4.29-.82-8.14.74-11.39l8.14,3.46q-.31.66-.6,1.38c-.15.38-.28.75-.4,1.13a1.09,1.09,0,0,0,0,.17,13.18,13.18,0,0,0-.39,1.32c-.12.46-.22.93-.29,1.38a7.59,7.59,0,0,0-.15,1.05,16.24,16.24,0,0,0,0,4.46l30,210.57c.54,3.82,2.44,6.44,5,7.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.66,64.77,83.13,211.46c-5.58,3.22-7.32,8.44-6.34,15.31l30.27,212.45c1,6.88,6.31,9.84,11.89,6.61L371.23,300.24c5.58-3.22,9.31-11.4,8.32-18.28l-30-210.58C348.57,64.51,343.24,61.55,337.66,64.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.74,299.27l-225.19,130c-2.89,1.67-5.65.14-6.16-3.42L94.69,217.4c-.51-3.56,1.42-7.8,4.31-9.47L324.19,78c2.89-1.67,5.65-.14,6.16,3.42l29.7,208.4C360.56,293.36,358.63,297.6,355.74,299.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.69,217.4l29.7,208.4c0,.14,0,.27.08.41L349.66,296.26c2.89-1.67,4.82-5.91,4.31-9.47L324.19,78,99,207.93C96.11,209.6,94.18,213.84,94.69,217.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.17,346.44a5,5,0,0,1-2.17,4.77c-1.45.84-2.84.07-3.09-1.73a5,5,0,0,1,2.17-4.76C104.53,343.88,105.92,344.65,106.17,346.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.33,297.64h0a3.94,3.94,0,0,0-1.69,3.71l4.92,34.31c.2,1.39,1.28,2,2.41,1.34h0a3.92,3.92,0,0,0,1.69-3.7L98.74,299C98.54,297.59,97.46,297,96.33,297.64Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Articles--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.19,78,99,207.93c-2.89,1.67-4.82,5.91-4.31,9.47l1,6.91,230.42-133Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.2,97.83h0c-.85.49-1.66,0-1.81-1l-.09-.59a3,3,0,0,1,1.27-2.79h0c.86-.49,1.67,0,1.82,1l.08.59A2.94,2.94,0,0,1,306.2,97.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.4,94.25h0c-.86.5-1.67,0-1.82-1l-.08-.58a3,3,0,0,1,1.27-2.8h0c.85-.49,1.66,0,1.81,1l.09.59A3,3,0,0,1,312.4,94.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.59,90.68h0c-.85.49-1.66,0-1.81-1l-.09-.59A3,3,0,0,1,318,86.29h0c.86-.5,1.67,0,1.82,1l.08.58A3,3,0,0,1,318.59,90.68Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tab--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.31,195.19,299.6,135a.63.63,0,0,1,1,.44l14.15,98.79a1.61,1.61,0,0,1-.76,1.47l-104.3,60.19a.63.63,0,0,1-1-.44l-14.15-98.79A1.57,1.57,0,0,1,195.31,195.19Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M306.79,138.14a1.36,1.36,0,0,0-1.11.19l-102.94,59.4a2.83,2.83,0,0,0-1.34,2.6l14,97.45a1.13,1.13,0,0,0,.59.92c-.31-.15-3.06-1.3-3.4-1.44a1.14,1.14,0,0,1-.62-.92l-14-97.46a2.84,2.84,0,0,1,1.34-2.6l102.93-59.41a1.33,1.33,0,0,1,1.2-.14C303.75,136.86,306.14,137.85,306.79,138.14Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.79,138.14c-.65-.29-3-1.28-3.34-1.41a1.33,1.33,0,0,0-1.2.14L199.32,196.28a2.9,2.9,0,0,0-1,1.14l3.43,1.45a2.8,2.8,0,0,1,1-1.14l102.94-59.4A1.36,1.36,0,0,1,306.79,138.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202.74,197.73l102.93-59.4c.88-.51,1.69-.16,1.82.77l14,97.46a2.84,2.84,0,0,1-1.34,2.6l-102.94,59.4c-.87.5-1.68.16-1.82-.77l-14-97.46A2.83,2.83,0,0,1,202.74,197.73Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.74,197.73l102.93-59.4c.88-.51,1.69-.16,1.82.77l14,97.46a2.84,2.84,0,0,1-1.34,2.6l-102.94,59.4c-.87.5-1.68.16-1.82-.77l-14-97.46A2.83,2.83,0,0,1,202.74,197.73Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.7,198.87l-3.43-1.45a2.48,2.48,0,0,0-.29,1.46l14,97.46a1.14,1.14,0,0,0,.62.92c.34.14,3.09,1.29,3.4,1.44a1.13,1.13,0,0,1-.59-.92l-14-97.45A2.49,2.49,0,0,1,201.7,198.87Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.7,198.87l-3.43-1.45a2.48,2.48,0,0,0-.29,1.46l14,97.46a1.14,1.14,0,0,0,.62.92c.34.14,3.09,1.29,3.4,1.44a1.13,1.13,0,0,1-.59-.92l-14-97.45A2.49,2.49,0,0,1,201.7,198.87Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.5,138.77c.15,0,.2.32.21.36l14,97.46a2.24,2.24,0,0,1-1,2L216.71,298a1,1,0,0,1-.35.13c-.15,0-.21-.33-.21-.37l-14-97.45a2.23,2.23,0,0,1,1-2l102.93-59.41a.84.84,0,0,1,.35-.12m-.1-.67a1.47,1.47,0,0,0-.73.23l-102.93,59.4a2.83,2.83,0,0,0-1.34,2.6l14,97.46a1,1,0,0,0,1.09,1,1.55,1.55,0,0,0,.73-.23l102.94-59.4a2.84,2.84,0,0,0,1.34-2.6l-14-97.46a1,1,0,0,0-1.09-1Z",
    style: {
      fill: "#00539C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.92,191.23a4.78,4.78,0,0,1,1.72-.66,2.82,2.82,0,0,1,1.32.09,1.89,1.89,0,0,1,.88.62,2.1,2.1,0,0,1,.43.92.62.62,0,0,1-.05.4.74.74,0,0,1-.26.29l-1,.58a.5.5,0,0,1-.38.09.61.61,0,0,1-.26-.18,1.22,1.22,0,0,0-.75-.39,2.34,2.34,0,0,0-1.34.42,4.09,4.09,0,0,0-.69.51,3.42,3.42,0,0,0-.54.61,2.45,2.45,0,0,0-.33.67,1.76,1.76,0,0,0,0,.68,1,1,0,0,0,.23.58.7.7,0,0,0,.51.17,4.05,4.05,0,0,0,.9-.14l1.36-.39a7.71,7.71,0,0,1,1.54-.32,2.27,2.27,0,0,1,1.12.16,1.56,1.56,0,0,1,.72.65,3.16,3.16,0,0,1,.38,1.16,4.51,4.51,0,0,1-.08,1.63,5.59,5.59,0,0,1-.64,1.62,7.44,7.44,0,0,1-1.19,1.51,8.26,8.26,0,0,1-1.67,1.27,5.78,5.78,0,0,1-1.56.64,3.27,3.27,0,0,1-1.38.06,2,2,0,0,1-1.06-.55,2.27,2.27,0,0,1-.58-1.18.56.56,0,0,1,.06-.4.63.63,0,0,1,.25-.3l1-.57a.6.6,0,0,1,.38-.11.46.46,0,0,1,.26.19,1.87,1.87,0,0,0,.31.32.77.77,0,0,0,.44.18,1.88,1.88,0,0,0,.64-.06,3.48,3.48,0,0,0,.92-.41,5.76,5.76,0,0,0,.81-.55,3.79,3.79,0,0,0,.66-.67,3,3,0,0,0,.42-.73,1.48,1.48,0,0,0,.09-.78.62.62,0,0,0-.29-.51,1.11,1.11,0,0,0-.66-.08,7.7,7.7,0,0,0-1,.25c-.42.13-.89.26-1.44.39a5.34,5.34,0,0,1-1.31.22,1.85,1.85,0,0,1-1-.2,1.58,1.58,0,0,1-.66-.69,4.16,4.16,0,0,1-.36-1.25,4.45,4.45,0,0,1,.08-1.62,5.94,5.94,0,0,1,.61-1.59,7.57,7.57,0,0,1,1.08-1.43A6.78,6.78,0,0,1,234.92,191.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.88,200.08a.28.28,0,0,1-.29,0,.29.29,0,0,1-.16-.26l-1.62-11.3a.72.72,0,0,1,.06-.4.69.69,0,0,1,.25-.3l1.15-.66a.28.28,0,0,1,.29,0,.32.32,0,0,1,.16.27l1.62,11.3a.72.72,0,0,1-.06.4.61.61,0,0,1-.25.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.17,190.4a7.69,7.69,0,0,1,0-2.09,6.93,6.93,0,0,1,1.8-3.69,7.75,7.75,0,0,1,1.79-1.41,5.39,5.39,0,0,1,2.09-.78,2.61,2.61,0,0,1,1.42.21,1.9,1.9,0,0,1,.83.75,3.3,3.3,0,0,1,.36.86.57.57,0,0,1-.06.4.62.62,0,0,1-.26.29l-1.15.67a.33.33,0,0,1-.26,0,.37.37,0,0,1-.17-.13,1.61,1.61,0,0,0-.19-.22A1.08,1.08,0,0,0,251,185a2,2,0,0,0-.75,0,2.79,2.79,0,0,0-1.1.41,4,4,0,0,0-1.6,1.69,4.05,4.05,0,0,0-.41,2.3c0,.45.1.93.17,1.44s.15,1,.24,1.41c.16.95.49,1.52,1,1.71a2.1,2.1,0,0,0,1.8-.33,4.69,4.69,0,0,0,.94-.7,3.43,3.43,0,0,0,1.08-2,4.51,4.51,0,0,0,0-1.37l0-.14-1.73,1a.28.28,0,0,1-.29,0,.34.34,0,0,1-.16-.27l-.18-1.24a.65.65,0,0,1,.07-.4.6.6,0,0,1,.25-.29l3.26-1.89a.26.26,0,0,1,.29,0,.29.29,0,0,1,.16.26l.28,1.92a7.7,7.7,0,0,1,0,2.09,7.06,7.06,0,0,1-1.8,3.77,7.92,7.92,0,0,1-1.84,1.45,5.36,5.36,0,0,1-1.93.73,2.4,2.4,0,0,1-1.46-.22,2.52,2.52,0,0,1-1-1,5.71,5.71,0,0,1-.58-1.75q-.06-.33-.12-.72c-.05-.27-.09-.54-.13-.82s-.08-.56-.11-.83S245.19,190.63,245.17,190.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.13,188.38q-.24.15-.39.06l-.22-.14-5-5,1,7.21a.72.72,0,0,1-.06.4.72.72,0,0,1-.25.29l-1.15.67a.28.28,0,0,1-.29,0,.32.32,0,0,1-.16-.27L255,180.34a.7.7,0,0,1,.06-.4.69.69,0,0,1,.25-.3l1-.57a.39.39,0,0,1,.39-.06l.22.14,5,5-1-7.21a.72.72,0,0,1,.06-.4.72.72,0,0,1,.25-.29l1.15-.66a.26.26,0,0,1,.29,0,.32.32,0,0,1,.16.27l1.62,11.3a.67.67,0,0,1-.06.39.69.69,0,0,1-.25.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.35,184.22a.28.28,0,0,1-.29,0,.29.29,0,0,1-.16-.26l-1.62-11.3a.72.72,0,0,1,.06-.4.69.69,0,0,1,.25-.3l1.15-.66a.28.28,0,0,1,.29,0,.35.35,0,0,1,.17.27l1.61,11.3a.72.72,0,0,1-.06.4.66.66,0,0,1-.25.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.55,178.33a.44.44,0,0,1-.4.06l-.22-.14-5-5,1,7.2a.71.71,0,0,1-.07.4.63.63,0,0,1-.25.3l-1.15.66a.28.28,0,0,1-.29,0,.34.34,0,0,1-.16-.27l-1.62-11.3a.73.73,0,0,1,.07-.4.6.6,0,0,1,.25-.29l1-.58a.38.38,0,0,1,.39,0,.93.93,0,0,1,.22.14l5,5-1-7.21a.65.65,0,0,1,.07-.4.56.56,0,0,1,.25-.29l1.15-.67a.28.28,0,0,1,.29,0,.32.32,0,0,1,.16.26l1.62,11.3a.83.83,0,0,1-.07.4.63.63,0,0,1-.25.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.08,253.09a1.35,1.35,0,0,1,1.2-.22,1.12,1.12,0,0,1,.55.95,2.37,2.37,0,0,1-.07,1,2.23,2.23,0,0,1-.5.9l1.08,1.34,0,.07a.25.25,0,0,1,0,.14.2.2,0,0,1-.08.1l-.51.29c-.08,0-.14.06-.18,0a.21.21,0,0,1-.1-.08l-1-1.26-.79.46.25,1.71a.45.45,0,0,1,0,.16.28.28,0,0,1-.11.13l-.48.28a.13.13,0,0,1-.12,0,.14.14,0,0,1-.07-.11l-.68-4.74a.55.55,0,0,1,0-.17.32.32,0,0,1,.11-.12Zm-.56,2.83.86-.5a1.47,1.47,0,0,0,.52-.46.87.87,0,0,0,.13-.67c0-.28-.14-.42-.28-.44a1.09,1.09,0,0,0-.57.18l-.86.5Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.58,255.15a3.37,3.37,0,0,1,0-.84,3.13,3.13,0,0,1,.2-.8,3,3,0,0,1,.4-.68,2.19,2.19,0,0,1,.59-.51,1.36,1.36,0,0,1,.62-.2,1,1,0,0,1,.52.14,1.15,1.15,0,0,1,.38.43,2,2,0,0,1,.21.65l0,.33a.27.27,0,0,1,0,.17.26.26,0,0,1-.11.12l-2,1.15a.57.57,0,0,0,.1.26.35.35,0,0,0,.19.13.63.63,0,0,0,.24,0,1.12,1.12,0,0,0,.26-.11,1.29,1.29,0,0,0,.3-.22.94.94,0,0,0,.18-.24,1,1,0,0,1,.1-.14.35.35,0,0,1,.11-.09l.47-.27a.12.12,0,0,1,.13,0,.11.11,0,0,1,.06.11.88.88,0,0,1-.05.32,2.15,2.15,0,0,1-.22.47,3.89,3.89,0,0,1-.38.5,2,2,0,0,1-.58.45,1.38,1.38,0,0,1-.62.21.85.85,0,0,1-.52-.14,1.18,1.18,0,0,1-.38-.46A2.39,2.39,0,0,1,246.58,255.15Zm1.3-2a1.11,1.11,0,0,0-.28.24.91.91,0,0,0-.18.27,1.18,1.18,0,0,0-.1.3.8.8,0,0,0,0,.26l1.34-.77a.9.9,0,0,0-.08-.21.36.36,0,0,0-.14-.16.35.35,0,0,0-.21,0A1,1,0,0,0,247.88,253.2Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,252.92s0-.09-.06-.1a.26.26,0,0,0-.16,0l-.29.08L251,253a1.2,1.2,0,0,1-.46.07.57.57,0,0,1-.31-.1.51.51,0,0,1-.2-.25,1.6,1.6,0,0,1-.1-.38,1.57,1.57,0,0,1,0-.48,2.18,2.18,0,0,1,.19-.52,2.61,2.61,0,0,1,.35-.49,2.2,2.2,0,0,1,.5-.4,2.06,2.06,0,0,1,.53-.22,1,1,0,0,1,.42,0,.62.62,0,0,1,.3.16.73.73,0,0,1,.15.29.27.27,0,0,1,0,.17.4.4,0,0,1-.1.12l-.46.26a.18.18,0,0,1-.14,0l-.11,0a.29.29,0,0,0-.16,0,.76.76,0,0,0-.27.11,1.1,1.1,0,0,0-.31.25.35.35,0,0,0-.1.31.14.14,0,0,0,.05.12.18.18,0,0,0,.14,0l.27-.06.44-.13a1,1,0,0,1,.81,0,.85.85,0,0,1,.32.62,1.35,1.35,0,0,1,0,.48,1.86,1.86,0,0,1-.2.52,2.54,2.54,0,0,1-.38.5,2.49,2.49,0,0,1-.54.43,2.12,2.12,0,0,1-.57.23,1,1,0,0,1-.45,0,.58.58,0,0,1-.3-.18.61.61,0,0,1-.15-.3.27.27,0,0,1,0-.17.28.28,0,0,1,.11-.13l.46-.26a.19.19,0,0,1,.14,0l.11.06a.34.34,0,0,0,.18,0,.78.78,0,0,0,.31-.13l.18-.12.17-.14a.88.88,0,0,0,.12-.17A.27.27,0,0,0,252,252.92Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.1,251.38a2.88,2.88,0,0,1,0-.83,3,3,0,0,1,.2-.8,2.65,2.65,0,0,1,.4-.69,2.3,2.3,0,0,1,.58-.5,1.4,1.4,0,0,1,.63-.2.92.92,0,0,1,.52.14,1.19,1.19,0,0,1,.38.42,2.13,2.13,0,0,1,.21.66l0,.33a.23.23,0,0,1,0,.16.27.27,0,0,1-.1.13l-2,1.15a.57.57,0,0,0,.1.26.32.32,0,0,0,.18.13.63.63,0,0,0,.24,0,.85.85,0,0,0,.26-.11,1.66,1.66,0,0,0,.31-.22,1.88,1.88,0,0,0,.18-.24,1.16,1.16,0,0,1,.09-.14.53.53,0,0,1,.11-.09l.48-.27a.11.11,0,0,1,.12,0,.13.13,0,0,1,.07.11,1.3,1.3,0,0,1-.06.32,2,2,0,0,1-.21.46,2.89,2.89,0,0,1-.39.51,2.58,2.58,0,0,1-.57.45,1.38,1.38,0,0,1-.62.21.83.83,0,0,1-.52-.14,1.27,1.27,0,0,1-.39-.46A2.39,2.39,0,0,1,253.1,251.38Zm1.3-1.94a1.4,1.4,0,0,0-.29.23,1.67,1.67,0,0,0-.18.28,1.18,1.18,0,0,0-.1.3c0,.1,0,.18,0,.26l1.35-.78-.08-.2a.36.36,0,0,0-.14-.16.38.38,0,0,0-.22-.05A.92.92,0,0,0,254.4,249.44Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.79,249.25a.39.39,0,0,0,.15.3c.08.06.2,0,.38-.07l.37-.21a.11.11,0,0,1,.12,0,.14.14,0,0,1,.07.11l.07.49a.3.3,0,0,1,0,.16.28.28,0,0,1-.11.13l-.44.25a1,1,0,0,1-.9.17c-.24-.11-.39-.39-.45-.85l-.23-1.58-.39.23a.13.13,0,0,1-.12,0,.13.13,0,0,1-.07-.11l-.07-.48a.26.26,0,0,1,0-.17.27.27,0,0,1,.1-.13l.4-.22-.18-1.2a.45.45,0,0,1,0-.16.28.28,0,0,1,.11-.13l.45-.26a.13.13,0,0,1,.12,0,.16.16,0,0,1,.07.12l.17,1.19.77-.44a.11.11,0,0,1,.12,0,.14.14,0,0,1,.07.11l.07.49a.3.3,0,0,1,0,.16.28.28,0,0,1-.11.13l-.76.44Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,242.75a1.37,1.37,0,0,1,1.18-.22c.31.12.5.45.58,1a2.38,2.38,0,0,1-.23,1.46,2.51,2.51,0,0,1-1,1.07l-1,.55.24,1.64a.55.55,0,0,1,0,.17.22.22,0,0,1-.11.12l-.48.28a.11.11,0,0,1-.12,0,.15.15,0,0,1-.07-.12l-.68-4.73a.34.34,0,0,1,0-.17.22.22,0,0,1,.11-.12Zm-.61,2.94.92-.53a1.43,1.43,0,0,0,.52-.48,1,1,0,0,0,.12-.7c0-.27-.13-.42-.28-.45a1,1,0,0,0-.57.16l-.92.53Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.36,243.83a2.32,2.32,0,0,1,.07-.39,2.14,2.14,0,0,1,.55-.95,2.35,2.35,0,0,1,.51-.41,1.67,1.67,0,0,1,.57-.21.79.79,0,0,1,.46,0,.77.77,0,0,1,.34.33,1.77,1.77,0,0,1,.19.6l.31,2.16a.51.51,0,0,1,0,.17.22.22,0,0,1-.11.12l-.45.26a.11.11,0,0,1-.12,0,.14.14,0,0,1-.07-.11l0-.24a2.29,2.29,0,0,1-.31.57,1.89,1.89,0,0,1-.58.49,1.6,1.6,0,0,1-.47.19.63.63,0,0,1-.37-.05.62.62,0,0,1-.27-.24,1.16,1.16,0,0,1-.14-.41,1.57,1.57,0,0,1,.18-1,2.82,2.82,0,0,1,.73-.83l.94-.77c0-.2-.1-.31-.22-.33a.65.65,0,0,0-.42.1.9.9,0,0,0-.23.19,1.54,1.54,0,0,0-.14.23l-.08.14a.39.39,0,0,1-.1.08l-.55.32a.14.14,0,0,1-.11,0A.1.1,0,0,1,264.36,243.83Zm1.3,1.49a1.56,1.56,0,0,0,.35-.27,1.85,1.85,0,0,0,.23-.34,1.74,1.74,0,0,0,.13-.36,1.24,1.24,0,0,0,0-.33V244l-.79.64a1.46,1.46,0,0,0-.33.35.57.57,0,0,0-.07.33c0,.1.07.16.16.16A.76.76,0,0,0,265.66,245.32Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.71,242.68a.15.15,0,0,0-.06-.11.27.27,0,0,0-.16,0,1.48,1.48,0,0,0-.29.07l-.46.14a1.77,1.77,0,0,1-.46.07.64.64,0,0,1-.32-.1.62.62,0,0,1-.19-.25,1.39,1.39,0,0,1-.1-.39,1.6,1.6,0,0,1,0-.48,2.11,2.11,0,0,1,.19-.51,2.27,2.27,0,0,1,.34-.49,2,2,0,0,1,.51-.4,1.54,1.54,0,0,1,.53-.22,1,1,0,0,1,.42,0,.55.55,0,0,1,.29.16.64.64,0,0,1,.16.29.27.27,0,0,1,0,.17.22.22,0,0,1-.11.12l-.46.27a.3.3,0,0,1-.14,0l-.11,0a.35.35,0,0,0-.15,0,.85.85,0,0,0-.28.12,1,1,0,0,0-.3.24.41.41,0,0,0-.11.32.17.17,0,0,0,.06.11s.07,0,.14,0l.27-.05.44-.14a1,1,0,0,1,.81,0,.82.82,0,0,1,.32.61,1.32,1.32,0,0,1,0,.48,2.22,2.22,0,0,1-.2.52,2.39,2.39,0,0,1-.93.93,1.89,1.89,0,0,1-.56.23,1.13,1.13,0,0,1-.45,0,.75.75,0,0,1-.3-.18.6.6,0,0,1-.15-.31.27.27,0,0,1,0-.17.26.26,0,0,1,.11-.12l.45-.27c.06,0,.11,0,.14,0a.67.67,0,0,1,.12.06.35.35,0,0,0,.18,0,.72.72,0,0,0,.31-.12l.18-.12.17-.15a.66.66,0,0,0,.12-.17A.32.32,0,0,0,269.71,242.68Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.8,240.89a.14.14,0,0,0-.06-.11.25.25,0,0,0-.16,0,1.67,1.67,0,0,0-.29.07l-.45.14a1.84,1.84,0,0,1-.47.07.6.6,0,0,1-.31-.1.54.54,0,0,1-.19-.25,1.41,1.41,0,0,1-.1-.38,1.31,1.31,0,0,1,0-.48,1.72,1.72,0,0,1,.19-.52,2,2,0,0,1,.34-.49,1.85,1.85,0,0,1,.51-.4,1.76,1.76,0,0,1,.53-.22,1,1,0,0,1,.42,0,.55.55,0,0,1,.29.16.58.58,0,0,1,.15.29.21.21,0,0,1,0,.17.36.36,0,0,1-.11.13l-.46.26c-.06,0-.1.05-.14,0l-.11,0h-.16a.92.92,0,0,0-.27.12,1.26,1.26,0,0,0-.31.25.4.4,0,0,0-.1.31.33.33,0,0,0,0,.12.2.2,0,0,0,.14,0,1.12,1.12,0,0,0,.27,0l.44-.14a1,1,0,0,1,.81,0,.8.8,0,0,1,.33.61,1.32,1.32,0,0,1,0,.48,2,2,0,0,1-.21.53,2.39,2.39,0,0,1-.37.5,2.58,2.58,0,0,1-.55.42,1.84,1.84,0,0,1-.57.23,1.08,1.08,0,0,1-.44,0,.69.69,0,0,1-.3-.18.6.6,0,0,1-.15-.31.31.31,0,0,1,0-.16.36.36,0,0,1,.11-.13l.46-.26c.06,0,.11-.05.14,0l.12.06a.4.4,0,0,0,.17,0,.92.92,0,0,0,.32-.13l.18-.12.17-.15a.83.83,0,0,0,.12-.16A.27.27,0,0,0,272.8,240.89Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.1,237.92l.23-2.4a.83.83,0,0,1,0-.15.22.22,0,0,1,.11-.13l.45-.26a.13.13,0,0,1,.12,0,.13.13,0,0,1,.07.11v0l-.42,3.9a.45.45,0,0,1,0,.16.33.33,0,0,1-.11.13l-.45.26c-.06,0-.1,0-.13,0a.36.36,0,0,1-.07-.1l-.86-1.62-.3,2.29a.94.94,0,0,1,0,.16.22.22,0,0,1-.11.13l-.45.26a.12.12,0,0,1-.13,0,.36.36,0,0,1-.07-.1l-1.38-2.86s0,0,0-.05a.45.45,0,0,1,0-.16.28.28,0,0,1,.11-.13l.45-.26c.06,0,.1,0,.13,0a.47.47,0,0,1,.06.09l.84,1.79.27-2.43a.56.56,0,0,1,0-.15.25.25,0,0,1,.1-.12l.45-.26a.11.11,0,0,1,.12,0,.18.18,0,0,1,.08.09Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,233.73a1.6,1.6,0,0,1,.6-.21.86.86,0,0,1,.51.08,1,1,0,0,1,.39.33,1.51,1.51,0,0,1,.22.55c0,.05,0,.1,0,.17l0,.2,0,.21a1.11,1.11,0,0,1,0,.17,2.8,2.8,0,0,1-.28,1.39,3.1,3.1,0,0,1-.41.61,2.35,2.35,0,0,1-.58.46,1.51,1.51,0,0,1-.61.22,1,1,0,0,1-.51-.07.94.94,0,0,1-.38-.34,1.44,1.44,0,0,1-.22-.55l0-.16,0-.2a1.49,1.49,0,0,1,0-.21,1.11,1.11,0,0,1,0-.17,2.6,2.6,0,0,1,.28-1.4,3.1,3.1,0,0,1,.41-.61A2.65,2.65,0,0,1,280,233.73Zm1,1.24a.73.73,0,0,0-.14-.33.43.43,0,0,0-.2-.14.39.39,0,0,0-.24,0,1.3,1.3,0,0,0-.25.1l-.24.18a1,1,0,0,0-.2.25,1.1,1.1,0,0,0-.14.33,1.48,1.48,0,0,0,0,.43s0,.09,0,.15l0,.19a1.13,1.13,0,0,0,0,.18,1.06,1.06,0,0,0,0,.14.78.78,0,0,0,.14.33.39.39,0,0,0,.2.14.4.4,0,0,0,.24,0,1.06,1.06,0,0,0,.25-.11.91.91,0,0,0,.23-.17,1,1,0,0,0,.21-.25,1.4,1.4,0,0,0,.17-.76,1,1,0,0,0,0-.15,1.11,1.11,0,0,1,0-.19l0-.18C280.93,235.05,280.92,235,280.91,235Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.72,232.59a1.17,1.17,0,0,0-.49.5,1.27,1.27,0,0,0-.07.72l.28,1.91a.3.3,0,0,1,0,.16.28.28,0,0,1-.11.13l-.45.26a.11.11,0,0,1-.12,0,.14.14,0,0,1-.07-.11l-.49-3.42a.34.34,0,0,1,0-.17.22.22,0,0,1,.11-.12l.45-.27a.13.13,0,0,1,.12,0,.14.14,0,0,1,.07.11l0,.17a2.81,2.81,0,0,1,.29-.46,1.54,1.54,0,0,1,.45-.37l.27-.15a.11.11,0,0,1,.12,0,.14.14,0,0,1,.07.11l.07.49a.27.27,0,0,1,0,.17.4.4,0,0,1-.1.12Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.77,230.38a1.55,1.55,0,0,1,.33-.15,1,1,0,0,1,.28,0,.65.65,0,0,1,.21,0l.14.07-.22-1.56a.33.33,0,0,1,0-.17.26.26,0,0,1,.11-.12l.45-.27a.13.13,0,0,1,.12,0,.14.14,0,0,1,.07.11l.69,4.81a.27.27,0,0,1,0,.17.2.2,0,0,1-.1.12l-.46.26a.11.11,0,0,1-.12,0,.14.14,0,0,1-.06-.11l0-.17a1.89,1.89,0,0,1-.1.21,1.92,1.92,0,0,1-.17.26,2.77,2.77,0,0,1-.24.25,1.57,1.57,0,0,1-.32.24,1.19,1.19,0,0,1-.56.17.85.85,0,0,1-.47-.15A1.11,1.11,0,0,1,285,234a2,2,0,0,1-.2-.59c0-.07,0-.15,0-.25a1.38,1.38,0,0,1,0-.26,2.82,2.82,0,0,1,0-.71,3.22,3.22,0,0,1,.19-.71,2.57,2.57,0,0,1,.36-.62A1.71,1.71,0,0,1,285.77,230.38Zm-.3,2.09a2.52,2.52,0,0,0,.06.41c.07.31.18.49.33.55a.58.58,0,0,0,.53-.08,1.15,1.15,0,0,0,.46-.49,1.4,1.4,0,0,0,.14-.74,1.68,1.68,0,0,0,0-.29,1.46,1.46,0,0,0,0-.27.65.65,0,0,0-.31-.47.57.57,0,0,0-.53.06,1.24,1.24,0,0,0-.46.5A1.49,1.49,0,0,0,285.47,232.47Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,262a2,2,0,0,1,.73-.28,1.39,1.39,0,0,1,.55,0,.83.83,0,0,1,.37.26,1,1,0,0,1,.18.38.25.25,0,0,1,0,.17.27.27,0,0,1-.1.13l-.42.24a.22.22,0,0,1-.16,0,.21.21,0,0,1-.11-.08.49.49,0,0,0-.32-.16,1,1,0,0,0-.56.17,2.09,2.09,0,0,0-.28.22,1.34,1.34,0,0,0-.23.25,1.46,1.46,0,0,0-.14.28.58.58,0,0,0,0,.29.38.38,0,0,0,.09.24.34.34,0,0,0,.22.08,2.32,2.32,0,0,0,.37-.07l.57-.16a3.23,3.23,0,0,1,.65-.13,1,1,0,0,1,.47.06.63.63,0,0,1,.3.28,1.18,1.18,0,0,1,.16.49,2,2,0,0,1,0,.68,2.3,2.3,0,0,1-.27.68,2.88,2.88,0,0,1-.5.63,3.39,3.39,0,0,1-.7.53,2.37,2.37,0,0,1-.65.27,1.45,1.45,0,0,1-.58,0,.94.94,0,0,1-.45-.24.91.91,0,0,1-.24-.49.25.25,0,0,1,0-.17.26.26,0,0,1,.11-.12l.42-.24a.24.24,0,0,1,.16-.05.21.21,0,0,1,.11.08l.13.13a.3.3,0,0,0,.18.08.86.86,0,0,0,.27,0,1.62,1.62,0,0,0,.39-.18,1.85,1.85,0,0,0,.34-.23,1.19,1.19,0,0,0,.27-.28,1,1,0,0,0,.18-.3.75.75,0,0,0,0-.33.31.31,0,0,0-.12-.22.59.59,0,0,0-.28,0,2.55,2.55,0,0,0-.44.11l-.6.16a2.09,2.09,0,0,1-.56.09.77.77,0,0,1-.41-.08.69.69,0,0,1-.27-.29,1.58,1.58,0,0,1-.16-.53,1.9,1.9,0,0,1,0-.67A2.59,2.59,0,0,1,250,263a3.2,3.2,0,0,1,.46-.6A2.71,2.71,0,0,1,251,262Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,260.2a.13.13,0,0,1,.12,0,.14.14,0,0,1,.07.11l.08.57a.33.33,0,0,1,0,.17.32.32,0,0,1-.11.12l-.51.3a.13.13,0,0,1-.12,0,.16.16,0,0,1-.07-.12l-.08-.57a.27.27,0,0,1,0-.17.24.24,0,0,1,.1-.12Zm.85,4.94a.27.27,0,0,1,0,.17.29.29,0,0,1-.1.12l-.45.26a.12.12,0,0,1-.13,0,.17.17,0,0,1-.06-.11l-.49-3.42a.26.26,0,0,1,0-.17.2.2,0,0,1,.1-.12l.45-.27a.13.13,0,0,1,.12,0,.14.14,0,0,1,.07.11Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.2,264.82a2,2,0,0,0,.25-.2,1.27,1.27,0,0,0,.21-.29,1.24,1.24,0,0,0,.16-.77l0-.27a2.21,2.21,0,0,1-.11.21,1.22,1.22,0,0,1-.16.26,2.77,2.77,0,0,1-.24.25,1.65,1.65,0,0,1-.33.24,1.13,1.13,0,0,1-.56.17.81.81,0,0,1-.46-.15,1.11,1.11,0,0,1-.35-.39,2,2,0,0,1-.2-.59,1.45,1.45,0,0,1,0-.25,1.38,1.38,0,0,1,0-.26,2.9,2.9,0,0,1,0-.72,3.29,3.29,0,0,1,.19-.7,2.57,2.57,0,0,1,.36-.62,1.6,1.6,0,0,1,.52-.45,1.55,1.55,0,0,1,.33-.15.93.93,0,0,1,.27,0,.65.65,0,0,1,.21,0,.52.52,0,0,1,.15.07l0-.17a.55.55,0,0,1,0-.17.26.26,0,0,1,.11-.12l.45-.26a.11.11,0,0,1,.12,0,.14.14,0,0,1,.07.11l.49,3.44a2.55,2.55,0,0,1-.21,1.57,2.45,2.45,0,0,1-1.05,1.09,1.67,1.67,0,0,1-.57.23,1.15,1.15,0,0,1-.49,0,.91.91,0,0,1-.36-.2.77.77,0,0,1-.18-.36.23.23,0,0,1,0-.16.28.28,0,0,1,.11-.13l.4-.23a.16.16,0,0,1,.16,0l.12.07a.32.32,0,0,0,.24.09A1,1,0,0,0,257.2,264.82Zm-1.12-2.44a1.77,1.77,0,0,0,.05.41c.08.31.19.49.34.55a.58.58,0,0,0,.53-.08,1.21,1.21,0,0,0,.46-.49,1.4,1.4,0,0,0,.14-.74,1.68,1.68,0,0,0,0-.29c0-.11,0-.2-.05-.27a.63.63,0,0,0-.32-.47.56.56,0,0,0-.52.06,1.24,1.24,0,0,0-.46.5A1.39,1.39,0,0,0,256.08,262.38Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.31,260.86a.45.45,0,0,1,0,.16.28.28,0,0,1-.11.13l-.45.26a.11.11,0,0,1-.12,0,.15.15,0,0,1-.07-.12l-.27-1.86a1,1,0,0,0-.26-.61c-.14-.11-.32-.1-.55,0a1,1,0,0,0-.46.55,1.45,1.45,0,0,0-.08.81l.26,1.86a.35.35,0,0,1,0,.17.32.32,0,0,1-.11.12l-.45.26a.11.11,0,0,1-.12,0,.14.14,0,0,1-.07-.11l-.49-3.42a.26.26,0,0,1,0-.17.2.2,0,0,1,.1-.12l.46-.26a.11.11,0,0,1,.12,0,.14.14,0,0,1,.06.11l0,.17a2.41,2.41,0,0,1,.32-.53,1.56,1.56,0,0,1,.47-.41,1.33,1.33,0,0,1,.63-.21.68.68,0,0,1,.45.15,1,1,0,0,1,.29.42,2.81,2.81,0,0,1,.15.62Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.94,256.22a.26.26,0,0,1,0-.17.27.27,0,0,1,.1-.13l.45-.26a.13.13,0,0,1,.12,0,.13.13,0,0,1,.07.11l.27,1.86a1,1,0,0,0,.25.62c.13.11.31.11.54,0a1,1,0,0,0,.44-.54,1.62,1.62,0,0,0,.07-.8L266,255a.26.26,0,0,1,0-.17.24.24,0,0,1,.1-.12l.45-.26a.12.12,0,0,1,.13,0,.14.14,0,0,1,.06.11l.49,3.42a.35.35,0,0,1,0,.17.26.26,0,0,1-.11.12l-.45.26a.11.11,0,0,1-.12,0,.14.14,0,0,1-.07-.11l0-.17a3.89,3.89,0,0,1-.3.5,1.47,1.47,0,0,1-.47.42,1.3,1.3,0,0,1-.62.21.74.74,0,0,1-.44-.16,1.07,1.07,0,0,1-.28-.43,2.68,2.68,0,0,1-.15-.62Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.81,256.82a1.87,1.87,0,0,1-.34.15,1.47,1.47,0,0,1-.27,0l-.21,0a.52.52,0,0,1-.15-.07l.23,1.56a.26.26,0,0,1,0,.17.25.25,0,0,1-.1.12l-.46.26a.11.11,0,0,1-.12,0,.14.14,0,0,1-.06-.11l-.69-4.81a.33.33,0,0,1,0-.17.22.22,0,0,1,.11-.12l.45-.27a.13.13,0,0,1,.12,0,.14.14,0,0,1,.07.11l0,.17c0-.06.07-.13.11-.22a1.59,1.59,0,0,1,.17-.25,1.84,1.84,0,0,1,.24-.26,2,2,0,0,1,.32-.23,1.09,1.09,0,0,1,.56-.17.8.8,0,0,1,.47.15,1.09,1.09,0,0,1,.34.39,1.8,1.8,0,0,1,.21.59c0,.07,0,.15,0,.25s0,.18,0,.26a2.83,2.83,0,0,1,0,.71,2.86,2.86,0,0,1-.19.71,2.91,2.91,0,0,1-.35.62A1.71,1.71,0,0,1,269.81,256.82Zm.3-2.09a2.37,2.37,0,0,0-.06-.41c-.07-.31-.18-.49-.34-.55a.59.59,0,0,0-.52.07,1.12,1.12,0,0,0-.46.5,1.39,1.39,0,0,0-.15.74c0,.08,0,.17,0,.29s0,.2.05.27a.66.66,0,0,0,.32.47.56.56,0,0,0,.52-.07,1.17,1.17,0,0,0,.47-.49A1.59,1.59,0,0,0,270.11,254.73Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.05,252.92a.34.34,0,0,1,0,.17.28.28,0,0,1-.11.13l-.45.26a.13.13,0,0,1-.12,0,.13.13,0,0,1-.07-.11l-.26-1.86a1,1,0,0,0-.27-.61c-.14-.11-.32-.1-.55,0a1,1,0,0,0-.46.55,1.57,1.57,0,0,0-.08.81l.26,1.87a.3.3,0,0,1,0,.16.28.28,0,0,1-.11.13l-.45.26a.11.11,0,0,1-.12,0,.13.13,0,0,1-.07-.11l-.49-3.41a.26.26,0,0,1,0-.17.34.34,0,0,1,.1-.13l.46-.26a.13.13,0,0,1,.12,0,.11.11,0,0,1,.06.11l0,.17a2.2,2.2,0,0,1,.32-.53,1.56,1.56,0,0,1,.47-.41,1.33,1.33,0,0,1,.63-.21.68.68,0,0,1,.45.15,1,1,0,0,1,.29.42,2.81,2.81,0,0,1,.15.62Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.67,248a1.56,1.56,0,0,1,.61-.22,1,1,0,0,1,.51.08,1.14,1.14,0,0,1,.39.34,1.44,1.44,0,0,1,.22.55s0,.1,0,.17l0,.2,0,.2c0,.07,0,.13,0,.17a2.83,2.83,0,0,1-.05.71,3.29,3.29,0,0,1-.23.69,2.77,2.77,0,0,1-.41.6,2.18,2.18,0,0,1-.58.47,1.51,1.51,0,0,1-.61.22,1,1,0,0,1-.51-.08,1,1,0,0,1-.38-.33,1.51,1.51,0,0,1-.22-.55s0-.1,0-.16l0-.2,0-.21c0-.07,0-.13,0-.17a2.44,2.44,0,0,1,0-.71,2.82,2.82,0,0,1,.24-.69,2.51,2.51,0,0,1,.41-.61A2.34,2.34,0,0,1,277.67,248Zm1,1.23a.73.73,0,0,0-.14-.32.37.37,0,0,0-.2-.14.49.49,0,0,0-.24,0,1.36,1.36,0,0,0-.25.11l-.24.17a1,1,0,0,0-.2.25,1.16,1.16,0,0,0-.14.34,1.48,1.48,0,0,0,0,.43s0,.09,0,.15a1.1,1.1,0,0,1,0,.18,1.06,1.06,0,0,0,0,.19,1.15,1.15,0,0,1,0,.14,1.08,1.08,0,0,0,.14.32.41.41,0,0,0,.21.15.66.66,0,0,0,.24,0,1.74,1.74,0,0,0,.25-.11l.23-.17a1,1,0,0,0,.21-.25,1.15,1.15,0,0,0,.13-.34,1.43,1.43,0,0,0,0-.43s0-.08,0-.14l0-.19a1.1,1.1,0,0,0,0-.18Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.13,247.38l.23-2.4a.83.83,0,0,1,0-.15.19.19,0,0,1,.1-.12l.46-.27a.13.13,0,0,1,.12,0,.11.11,0,0,1,.06.11.11.11,0,0,1,0,0l-.42,3.9a.9.9,0,0,1,0,.16.25.25,0,0,1-.12.13l-.45.26a.11.11,0,0,1-.12,0l-.08-.1-.85-1.62-.3,2.29a.75.75,0,0,1,0,.16.27.27,0,0,1-.11.13l-.45.26c-.06,0-.1,0-.13,0a.36.36,0,0,1-.07-.1l-1.38-2.86s0,0,0,0a.23.23,0,0,1,0-.16.28.28,0,0,1,.11-.13l.45-.26a.11.11,0,0,1,.12,0l.07.09.84,1.79.27-2.43a.34.34,0,0,1,0-.15.24.24,0,0,1,.1-.12l.45-.26a.11.11,0,0,1,.12,0,.13.13,0,0,1,.07.09Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.72,187.06l-91.78,53c-.52.3-1,0-1.11-.61l-1.4-9.77a1.8,1.8,0,0,1,.78-1.7L305,175c.52-.3,1,0,1.1.61l1.4,9.77A1.8,1.8,0,0,1,306.72,187.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.93,232.33a.12.12,0,0,1,.13,0,.13.13,0,0,1,.07.12l.08.56a.29.29,0,0,1,0,.18.23.23,0,0,1-.11.14L217.25,235a.12.12,0,0,1-.13,0,.2.2,0,0,1-.08-.12l-.73-5.12a.29.29,0,0,1,0-.18.4.4,0,0,1,.11-.14l2.78-1.6a.12.12,0,0,1,.13,0,.15.15,0,0,1,.07.12l.08.56a.29.29,0,0,1,0,.18.29.29,0,0,1-.11.13l-2.08,1.2.18,1.26,1.94-1.11a.12.12,0,0,1,.13,0,.15.15,0,0,1,.07.12l.08.56a.29.29,0,0,1,0,.18.4.4,0,0,1-.11.14l-1.94,1.11.19,1.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.76,230.86a.12.12,0,0,1-.13,0,.15.15,0,0,1-.07-.12l-.08-.52a.33.33,0,0,1,0-.19.3.3,0,0,1,.12-.13l2-1.13a.12.12,0,0,1,.13,0,.15.15,0,0,1,.07.12l.08.53a.27.27,0,0,1,0,.17.28.28,0,0,1-.12.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.32,226.83a2,2,0,0,1,.32-.56,1.59,1.59,0,0,1,.44-.39,1.15,1.15,0,0,1,.69-.2.77.77,0,0,1,.48.26,2.05,2.05,0,0,1,.16-.41,3.17,3.17,0,0,1,.23-.36,2.61,2.61,0,0,1,.27-.3,2.55,2.55,0,0,1,.28-.21,1.23,1.23,0,0,1,.64-.2.69.69,0,0,1,.45.18,1.23,1.23,0,0,1,.3.46,4,4,0,0,1,.16.68l.3,2.13a.29.29,0,0,1,0,.18.28.28,0,0,1-.11.13l-.49.28a.12.12,0,0,1-.13,0,.15.15,0,0,1-.07-.12l-.3-2.09c0-.36-.15-.58-.28-.66a.52.52,0,0,0-.5.06,1,1,0,0,0-.41.46,1.53,1.53,0,0,0-.09.83l.3,2.14a.27.27,0,0,1,0,.17.23.23,0,0,1-.11.14l-.49.28a.12.12,0,0,1-.13,0,.15.15,0,0,1-.07-.12l-.3-2.09c-.05-.36-.14-.58-.28-.66a.47.47,0,0,0-.5.06,1.11,1.11,0,0,0-.42.48,1.51,1.51,0,0,0-.08.85l.3,2.09a.29.29,0,0,1,0,.18.23.23,0,0,1-.11.14l-.49.28a.12.12,0,0,1-.13,0,.19.19,0,0,1-.07-.12l-.53-3.7a.31.31,0,0,1,0-.18.36.36,0,0,1,.11-.13l.49-.28a.12.12,0,0,1,.13,0,.15.15,0,0,1,.08.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.48,224.52a2.61,2.61,0,0,1,.07-.42,3.45,3.45,0,0,1,.21-.51,3,3,0,0,1,.38-.52,3.11,3.11,0,0,1,.56-.44,2,2,0,0,1,.61-.23.92.92,0,0,1,.5,0,.83.83,0,0,1,.37.35,2.06,2.06,0,0,1,.2.66l.34,2.33a.39.39,0,0,1,0,.18.24.24,0,0,1-.11.13l-.49.28a.12.12,0,0,1-.13,0,.15.15,0,0,1-.07-.12l0-.26a2.29,2.29,0,0,1-.33.61,2,2,0,0,1-.63.54,1.53,1.53,0,0,1-.5.2.78.78,0,0,1-.41-.05.63.63,0,0,1-.28-.26,1,1,0,0,1-.15-.45,1.65,1.65,0,0,1,.19-1,3.1,3.1,0,0,1,.78-.9l1-.83q0-.33-.24-.36a.7.7,0,0,0-.45.12.61.61,0,0,0-.24.2.87.87,0,0,0-.15.25,1,1,0,0,1-.1.14.28.28,0,0,1-.1.09l-.6.35a.14.14,0,0,1-.11,0S229.48,224.58,229.48,224.52Zm1.4,1.62a2.28,2.28,0,0,0,.38-.3,1.72,1.72,0,0,0,.25-.37,1.53,1.53,0,0,0,.14-.39,1.38,1.38,0,0,0,0-.35v-.08l-.85.69a1.74,1.74,0,0,0-.36.38.59.59,0,0,0-.07.36.15.15,0,0,0,.17.16A.72.72,0,0,0,230.88,226.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.49,219.48s.09,0,.13,0a.13.13,0,0,1,.07.12l.09.62a.36.36,0,0,1-.14.31l-.55.32a.1.1,0,0,1-.13,0,.15.15,0,0,1-.08-.12l-.08-.61a.37.37,0,0,1,0-.18.28.28,0,0,1,.12-.14Zm.92,5.33a.38.38,0,0,1,0,.18.26.26,0,0,1-.12.13l-.49.29a.12.12,0,0,1-.13,0,.15.15,0,0,1-.07-.12L233,221.6a.29.29,0,0,1,0-.18.36.36,0,0,1,.11-.13l.49-.28a.12.12,0,0,1,.13,0,.14.14,0,0,1,.08.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.13,223.82a.31.31,0,0,1,0,.18.36.36,0,0,1-.11.13l-.49.28a.12.12,0,0,1-.13,0,.15.15,0,0,1-.08-.12l-.74-5.2a.3.3,0,0,1,0-.18.36.36,0,0,1,.11-.13l.49-.28a.12.12,0,0,1,.13,0,.15.15,0,0,1,.08.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.61,207.16l-91.79,53c-.52.3-1,0-1.1-.61l-1.4-9.77a1.8,1.8,0,0,1,.77-1.7l91.79-53c.51-.3,1,0,1.1.61l1.4,9.77A1.82,1.82,0,0,1,309.61,207.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.06,248.51a1.51,1.51,0,0,1,1.28-.25c.33.14.53.49.62,1.07a2.61,2.61,0,0,1-.24,1.58,2.85,2.85,0,0,1-1.15,1.16l-1,.6.26,1.76a.57.57,0,0,1,0,.18.33.33,0,0,1-.12.14l-.52.3a.12.12,0,0,1-.13,0,.15.15,0,0,1-.07-.12l-.74-5.11a.57.57,0,0,1,0-.18.28.28,0,0,1,.12-.14Zm-.66,3.17,1-.58a1.63,1.63,0,0,0,.56-.51,1.1,1.1,0,0,0,.13-.75c0-.3-.15-.46-.31-.49a.9.9,0,0,0-.61.17l-1,.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.62,249.67a1.83,1.83,0,0,1,.07-.42,2.2,2.2,0,0,1,.21-.51,3,3,0,0,1,.38-.52,2.8,2.8,0,0,1,.56-.44,1.93,1.93,0,0,1,.61-.23.84.84,0,0,1,.5,0,.76.76,0,0,1,.36.35,1.84,1.84,0,0,1,.21.65l.33,2.34a.27.27,0,0,1,0,.17.23.23,0,0,1-.11.14l-.49.28a.12.12,0,0,1-.13,0,.16.16,0,0,1-.07-.12l0-.26a2.29,2.29,0,0,1-.33.61,2,2,0,0,1-.63.54,1.49,1.49,0,0,1-.5.19.62.62,0,0,1-.69-.3,1,1,0,0,1-.15-.45,1.64,1.64,0,0,1,.19-1,3.13,3.13,0,0,1,.78-.91l1-.82q0-.33-.24-.36a.68.68,0,0,0-.45.11.71.71,0,0,0-.24.2,2.13,2.13,0,0,0-.16.25.49.49,0,0,1-.09.15.43.43,0,0,1-.1.09l-.6.34a.13.13,0,0,1-.12,0A.12.12,0,0,1,223.62,249.67Zm1.4,1.61a1.35,1.35,0,0,0,.37-.3,1.27,1.27,0,0,0,.26-.36,1.2,1.2,0,0,0,.13-.39,1.12,1.12,0,0,0,0-.36v-.08l-.85.7a1.54,1.54,0,0,0-.36.38.51.51,0,0,0-.07.36.15.15,0,0,0,.17.16A.74.74,0,0,0,225,251.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.39,248.42a.13.13,0,0,0-.07-.11.27.27,0,0,0-.17,0l-.31.08-.49.15a1.42,1.42,0,0,1-.5.07.6.6,0,0,1-.34-.1.58.58,0,0,1-.21-.27,2.22,2.22,0,0,1-.11-.41,1.56,1.56,0,0,1,0-.52,1.71,1.71,0,0,1,.2-.56,2.31,2.31,0,0,1,.37-.53,2.27,2.27,0,0,1,.54-.43,2.24,2.24,0,0,1,.58-.24,1,1,0,0,1,.45,0,.53.53,0,0,1,.32.17.62.62,0,0,1,.16.31.23.23,0,0,1,0,.18.33.33,0,0,1-.12.14l-.49.28a.22.22,0,0,1-.16,0l-.12,0h-.16a.86.86,0,0,0-.3.13,1.23,1.23,0,0,0-.33.26.41.41,0,0,0-.11.34.18.18,0,0,0,.06.13s.07,0,.15,0l.29-.06.47-.15a1.08,1.08,0,0,1,.88,0,.92.92,0,0,1,.35.66,1.56,1.56,0,0,1,0,.52,2.07,2.07,0,0,1-.23.56,2.32,2.32,0,0,1-.41.55,2.37,2.37,0,0,1-.58.45,1.71,1.71,0,0,1-.62.25.93.93,0,0,1-.47,0,.62.62,0,0,1-.33-.2.57.57,0,0,1-.16-.33.27.27,0,0,1,0-.17.33.33,0,0,1,.11-.14l.5-.29a.17.17,0,0,1,.15,0l.13.06a.5.5,0,0,0,.19,0,.84.84,0,0,0,.33-.14,1.13,1.13,0,0,0,.2-.13.93.93,0,0,0,.18-.16.46.46,0,0,0,.13-.18A.24.24,0,0,0,229.39,248.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.73,246.49a.14.14,0,0,0-.06-.11.23.23,0,0,0-.17,0,1.89,1.89,0,0,0-.32.07l-.49.15a1.39,1.39,0,0,1-.5.07.62.62,0,0,1-.34-.1.58.58,0,0,1-.21-.27,1.54,1.54,0,0,1-.1-.41,1.32,1.32,0,0,1,0-.52,2.35,2.35,0,0,1,.2-.56,3,3,0,0,1,.37-.53,2.33,2.33,0,0,1,.55-.43,1.66,1.66,0,0,1,.57-.24,1,1,0,0,1,.46,0,.56.56,0,0,1,.32.17.66.66,0,0,1,.16.31.29.29,0,0,1,0,.18.29.29,0,0,1-.11.13l-.5.29a.2.2,0,0,1-.15,0l-.12,0a.46.46,0,0,0-.17,0,.86.86,0,0,0-.3.13,1.64,1.64,0,0,0-.33.26.41.41,0,0,0-.11.34.23.23,0,0,0,.06.13.28.28,0,0,0,.15,0l.29-.06.48-.14a1,1,0,0,1,.87,0,.89.89,0,0,1,.35.66,1.56,1.56,0,0,1,0,.52,2,2,0,0,1-.22.56,2.62,2.62,0,0,1-.41.55,2.7,2.7,0,0,1-.59.45,1.68,1.68,0,0,1-.61.25,1,1,0,0,1-.48,0,.66.66,0,0,1-.33-.2.73.73,0,0,1-.16-.33.27.27,0,0,1,0-.17.28.28,0,0,1,.12-.14l.49-.29c.07,0,.12,0,.15,0l.13.06a.5.5,0,0,0,.19,0,.93.93,0,0,0,.34-.14,1.07,1.07,0,0,0,.19-.13l.19-.16.13-.18A.29.29,0,0,0,232.73,246.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.37,243.29l.26-2.6a1.1,1.1,0,0,1,0-.16.25.25,0,0,1,.12-.13l.49-.28a.12.12,0,0,1,.13,0,.13.13,0,0,1,.07.12.06.06,0,0,1,0,.06L238,244.5a1.36,1.36,0,0,1,0,.17.27.27,0,0,1-.12.14l-.49.28c-.06,0-.11,0-.13,0a.39.39,0,0,1-.08-.1l-.93-1.76-.32,2.48c0,.06,0,.11,0,.17a.25.25,0,0,1-.12.13l-.49.29a.14.14,0,0,1-.14,0,.36.36,0,0,1-.07-.1l-1.5-3.09a.11.11,0,0,1,0-.06.31.31,0,0,1,0-.18.28.28,0,0,1,.11-.13l.49-.28c.06,0,.1,0,.13,0a.39.39,0,0,1,.08.1l.9,1.93.29-2.63a.71.71,0,0,1,0-.16.24.24,0,0,1,.11-.13l.48-.28a.12.12,0,0,1,.13,0,.22.22,0,0,1,.08.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.46,238.77a1.57,1.57,0,0,1,.66-.24,1,1,0,0,1,.55.09,1.08,1.08,0,0,1,.41.36,1.93,1.93,0,0,1,.27.78l0,.22a1.7,1.7,0,0,1,0,.22c0,.07,0,.13,0,.18a2.79,2.79,0,0,1-.06.76,2.88,2.88,0,0,1-.25.75,2.76,2.76,0,0,1-.44.65,2.31,2.31,0,0,1-.62.5,1.67,1.67,0,0,1-.66.24,1.1,1.1,0,0,1-.55-.08,1.08,1.08,0,0,1-.41-.36,1.8,1.8,0,0,1-.24-.6,1.46,1.46,0,0,1,0-.17l0-.22,0-.22a1.76,1.76,0,0,1,0-.19,2.81,2.81,0,0,1,0-.76,3.31,3.31,0,0,1,.25-.75,3,3,0,0,1,.45-.66A2.17,2.17,0,0,1,240.46,238.77Zm1,1.33a1,1,0,0,0-.15-.35.54.54,0,0,0-.22-.16.58.58,0,0,0-.26,0,1.59,1.59,0,0,0-.27.12,1.43,1.43,0,0,0-.26.19,1.09,1.09,0,0,0-.21.26,1.11,1.11,0,0,0-.15.37,1.64,1.64,0,0,0,0,.46s0,.1,0,.16a1.36,1.36,0,0,0,0,.2l0,.2,0,.15a.75.75,0,0,0,.15.36.4.4,0,0,0,.22.15.43.43,0,0,0,.25,0,.8.8,0,0,0,.27-.12,1.51,1.51,0,0,0,.26-.18,1.44,1.44,0,0,0,.22-.27,1.79,1.79,0,0,0,.15-.37,1.67,1.67,0,0,0,0-.46,1,1,0,0,0,0-.16l0-.2,0-.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.52,237.54a1.23,1.23,0,0,0-.53.53,1.47,1.47,0,0,0-.07.78l.3,2.06a.38.38,0,0,1,0,.18.26.26,0,0,1-.12.13l-.48.29a.14.14,0,0,1-.14,0,.15.15,0,0,1-.07-.12l-.53-3.69a.29.29,0,0,1,0-.18.3.3,0,0,1,.12-.13l.48-.28a.14.14,0,0,1,.14,0,.15.15,0,0,1,.07.12l0,.18a2.23,2.23,0,0,1,.31-.5,1.94,1.94,0,0,1,.48-.39l.29-.17a.15.15,0,0,1,.13,0,.15.15,0,0,1,.08.12l.07.52a.29.29,0,0,1,0,.18.24.24,0,0,1-.11.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.73,235.15a1.25,1.25,0,0,1,.37-.16.78.78,0,0,1,.29,0,.69.69,0,0,1,.22,0l.16.08-.24-1.69a.29.29,0,0,1,0-.18.29.29,0,0,1,.11-.13l.49-.29a.15.15,0,0,1,.13,0,.15.15,0,0,1,.08.12l.74,5.2a.27.27,0,0,1,0,.17.33.33,0,0,1-.11.14l-.49.28a.12.12,0,0,1-.13,0,.17.17,0,0,1-.08-.12l0-.19a2.67,2.67,0,0,1-.12.24,1.34,1.34,0,0,1-.17.27,2.34,2.34,0,0,1-.27.28,2,2,0,0,1-.35.25,1.21,1.21,0,0,1-.6.18.84.84,0,0,1-.5-.15,1.34,1.34,0,0,1-.38-.43,2.22,2.22,0,0,1-.22-.63c0-.08,0-.17,0-.28a1.49,1.49,0,0,1,0-.28,3,3,0,0,1,.22-1.53,2.7,2.7,0,0,1,.38-.66A1.85,1.85,0,0,1,246.73,235.15Zm-.32,2.26a3.11,3.11,0,0,0,.06.44c.08.33.2.53.37.59a.62.62,0,0,0,.56-.08,1.25,1.25,0,0,0,.5-.54,1.49,1.49,0,0,0,.15-.8,2.11,2.11,0,0,0,0-.31,1.72,1.72,0,0,0-.05-.29.71.71,0,0,0-.34-.51.63.63,0,0,0-.57.07,1.25,1.25,0,0,0-.5.54A1.72,1.72,0,0,0,246.41,237.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Eye--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.24,207.61a4,4,0,0,1-4.63-.51l-.07-.06,0-.14s1.24-4,3.78-5.41A4,4,0,0,1,307,202l.07.07-.05.13S305.77,206.15,303.24,207.61Zm-4.42-.74a3.79,3.79,0,0,0,4.37.43c2.17-1.26,3.35-4.34,3.59-5a3.75,3.75,0,0,0-4.37-.47C300.24,203.06,299.06,206.18,298.82,206.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.46,202.21a3.64,3.64,0,0,0-1.57,3.44c.19,1.29,1.19,1.85,2.24,1.24a3.65,3.65,0,0,0,1.57-3.44C304.51,202.16,303.51,201.6,302.46,202.21Zm.5,3.47c-.5.3-1,0-1.08-.6a1.75,1.75,0,0,1,.76-1.66c.5-.29,1,0,1.08.6A1.75,1.75,0,0,1,303,205.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-43",
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.6,358.92,325.26,250c.78-.45,1.5-.14,1.62.69l3.2,22.31a2.52,2.52,0,0,1-1.2,2.32L140.23,384.24c-.78.45-1.51.14-1.62-.69l-3.2-22.31A2.53,2.53,0,0,1,136.6,358.92Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.92,255.84,141.13,361.33a2.75,2.75,0,0,0-1.32,2.55l2.84,19.79a3.54,3.54,0,0,0,2,2.4l3.41,1.42a4.31,4.31,0,0,0,3.35-.15L334.23,281.86a2.78,2.78,0,0,0,1.32-2.56l-2.84-19.79a3.54,3.54,0,0,0-2-2.4l-3.41-1.42A4.31,4.31,0,0,0,323.92,255.84Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.44,387.34a4.37,4.37,0,0,1-3.35.15l-3.41-1.42a3.54,3.54,0,0,1-2-2.4l-2.84-19.79a2.54,2.54,0,0,1,.33-1.49l7,3a2.31,2.31,0,0,0-.29,1.43l2.83,19.79A1.1,1.1,0,0,0,151.44,387.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.66,259.26c-.24-.72-1-.95-1.74-.51L148.14,364.24a2.73,2.73,0,0,0-1,1.12l-7-3a2.79,2.79,0,0,1,1-1.07l182.8-105.48a4.28,4.28,0,0,1,3.34-.15l3.41,1.42A3.66,3.66,0,0,1,332.66,259.26Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M330.92,258.75,148.13,364.24a2.76,2.76,0,0,0-1.31,2.55l.57,4,2.26,15.78c.13.91.93,1.25,1.79.76L334.23,281.86a2.78,2.78,0,0,0,1.32-2.56l-2.84-19.79C332.58,258.6,331.78,258.26,330.92,258.75Z",
    style: {
      fill: "#00539C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.41,331.79a.25.25,0,0,1,.26,0,.34.34,0,0,1,.15.24l.16,1.13a.58.58,0,0,1-.06.36.62.62,0,0,1-.23.27L226.06,337a.25.25,0,0,1-.26,0,.3.3,0,0,1-.15-.24l-1.47-10.23a.66.66,0,0,1,.07-.36.6.6,0,0,1,.22-.27l1-.6a.24.24,0,0,1,.27,0,.27.27,0,0,1,.14.24l1.25,8.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.9,322.82a3.4,3.4,0,0,1,1.32-.47,2,2,0,0,1,1.1.18,2.1,2.1,0,0,1,.83.72,3,3,0,0,1,.48,1.19c0,.09.05.21.07.36l.06.44.06.44a2.81,2.81,0,0,1,0,.36,5.73,5.73,0,0,1-.1,1.54,5.82,5.82,0,0,1-1.39,2.79,5,5,0,0,1-1.24,1,3.35,3.35,0,0,1-1.32.47,2.1,2.1,0,0,1-1.1-.17,2.07,2.07,0,0,1-.82-.72,3.49,3.49,0,0,1-.49-1.19l-.07-.34c0-.14-.05-.29-.07-.43s0-.3,0-.45,0-.28,0-.38a5.31,5.31,0,0,1,.1-1.53,6.56,6.56,0,0,1,.51-1.49,5.84,5.84,0,0,1,.88-1.32A5.28,5.28,0,0,1,234.9,322.82Zm2.07,2.67a1.74,1.74,0,0,0-.3-.71.83.83,0,0,0-.44-.3,1,1,0,0,0-.52,0,2.66,2.66,0,0,0-.53.23,3.14,3.14,0,0,0-.52.38,2.36,2.36,0,0,0-.44.54,2.31,2.31,0,0,0-.29.72,3.06,3.06,0,0,0-.07.93c0,.09,0,.19,0,.32s0,.27.05.4,0,.28.07.4a2.6,2.6,0,0,0,.06.3,1.74,1.74,0,0,0,.31.71.78.78,0,0,0,.43.3.92.92,0,0,0,.52,0,2.5,2.5,0,0,0,.54-.23,3.07,3.07,0,0,0,.51-.38,2.16,2.16,0,0,0,.44-.54,2.6,2.6,0,0,0,.3-.72,3,3,0,0,0,.06-.92,2.23,2.23,0,0,0,0-.32c0-.13,0-.27,0-.41l-.06-.39C237,325.67,237,325.57,237,325.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,328.4a2.83,2.83,0,0,0,.54-.42,3,3,0,0,0,.77-1.41,2.59,2.59,0,0,0,0-.88l-.08-.59a5,5,0,0,1-.23.47,6.32,6.32,0,0,1-.36.54,5.31,5.31,0,0,1-.52.56,3.8,3.8,0,0,1-.7.5,2.41,2.41,0,0,1-1.21.37,1.79,1.79,0,0,1-1-.31,2.44,2.44,0,0,1-.75-.86,3.76,3.76,0,0,1-.44-1.26c0-.16-.06-.34-.09-.55a4.49,4.49,0,0,1-.07-.56,6.15,6.15,0,0,1,0-1.54,6,6,0,0,1,.41-1.52,5.53,5.53,0,0,1,.76-1.34,4,4,0,0,1,1.12-1,3.39,3.39,0,0,1,.73-.32,2.24,2.24,0,0,1,.59-.08,1.52,1.52,0,0,1,.45.07,1.27,1.27,0,0,1,.31.16l0-.37a.68.68,0,0,1,.06-.36.54.54,0,0,1,.23-.26l1-.57a.26.26,0,0,1,.27,0,.27.27,0,0,1,.14.24l1.07,7.43a5.66,5.66,0,0,1-.46,3.39,5.52,5.52,0,0,1-2.26,2.36,3.9,3.9,0,0,1-1.24.49,2.5,2.5,0,0,1-1.06,0,1.68,1.68,0,0,1-.77-.43,1.5,1.5,0,0,1-.4-.77.52.52,0,0,1,.05-.36.64.64,0,0,1,.24-.27l.87-.5a.33.33,0,0,1,.33,0l.26.15a.88.88,0,0,0,.52.18A2.08,2.08,0,0,0,244,328.4Zm-2.42-5.26a5,5,0,0,0,.12.89c.15.66.4,1.05.73,1.18a1.25,1.25,0,0,0,1.13-.16,2.53,2.53,0,0,0,1-1.07,3.13,3.13,0,0,0,.31-1.6c0-.17,0-.38-.06-.62s-.08-.44-.12-.59a1.35,1.35,0,0,0-.68-1,1.18,1.18,0,0,0-1.13.14,2.59,2.59,0,0,0-1,1.07A3.24,3.24,0,0,0,241.54,323.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.56,311.85a.25.25,0,0,1,.26,0,.3.3,0,0,1,.14.24l.18,1.24a.6.6,0,0,1-.06.36.54.54,0,0,1-.23.26l-1.1.64a.25.25,0,0,1-.26,0,.34.34,0,0,1-.15-.24l-.18-1.24a.8.8,0,0,1,.06-.36.62.62,0,0,1,.23-.27Zm1.83,10.66a.76.76,0,0,1-.06.36.57.57,0,0,1-.23.27l-1,.56a.25.25,0,0,1-.26,0,.3.3,0,0,1-.14-.24l-1.06-7.39a.6.6,0,0,1,.06-.36.52.52,0,0,1,.22-.26l1-.57a.25.25,0,0,1,.26,0,.28.28,0,0,1,.15.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.44,317.86a.58.58,0,0,1-.06.36.52.52,0,0,1-.23.27l-1,.56a.27.27,0,0,1-.27,0,.33.33,0,0,1-.14-.24l-.58-4a2,2,0,0,0-.58-1.31c-.29-.24-.69-.22-1.18.07a2.27,2.27,0,0,0-1,1.19,3.5,3.5,0,0,0-.17,1.75l.58,4a.76.76,0,0,1-.06.36.62.62,0,0,1-.23.27l-1,.56a.25.25,0,0,1-.26,0,.34.34,0,0,1-.15-.24l-1-7.39a.6.6,0,0,1,.06-.36.52.52,0,0,1,.22-.26l1-.57a.25.25,0,0,1,.26,0,.3.3,0,0,1,.15.24l.05.36a5.27,5.27,0,0,1,.69-1.13,3.44,3.44,0,0,1,1-.89,2.81,2.81,0,0,1,1.35-.45,1.42,1.42,0,0,1,1,.32,2.07,2.07,0,0,1,.62.91,5.71,5.71,0,0,1,.34,1.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.67,333.43l62.51-36.08-4-19.37c-1.55-5.59-4.73-9.41-8.75-11.12l-5.4-2.29c-4-1.69-8.84-1.29-13.73,1.53L146,278.42c-9.81,5.66-16.85,19.35-16.52,32.1l1.78,20.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.23,278c-1.55-5.59-4.73-9.41-8.75-11.12s-8.84-1.29-13.73,1.53l-21.34,12.32c-9.81,5.66-16.85,19.35-16.51,32.1l1.77,20.62,62.51-36.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.46,225.94c3.79,1.61,6.51,5.28,7.28,10.63,1.53,10.7-5.36,24.08-15.4,29.87-5,2.9-9.87,3.35-13.66,1.75L141.46,266c-3.79-1.6-6.51-5.28-7.28-10.63-1.53-10.7,5.36-24.08,15.4-29.87,5-2.9,9.87-3.35,13.66-1.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.34,266.44c-5,2.9-9.87,3.35-13.66,1.75s-6.52-5.28-7.28-10.64c-1.54-10.7,5.36-24.08,15.39-29.87,5-2.9,9.87-3.35,13.67-1.74s6.51,5.28,7.28,10.63C177.27,247.27,170.38,260.65,160.34,266.44Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.28,414.87l-58.08,0,6,25h0c.45,3,2.67,6,6.67,8.27,9,5.22,23.68,5.22,32.71,0,4.31-2.48,6.54-5.7,6.74-9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2,432a23.8,23.8,0,0,0,3.49-2.43L85,416.21a23.64,23.64,0,0,1-5.88,4.67c-12.25,7.07-31.89,7.25-44.56.58l1.48-6-.46-.63H27.2l6,25h0c.45,3,2.67,6,6.67,8.27,6.44,3.72,15.71,4.77,23.79,3.19-14.47,1.08-24.4-5.24-25.89-11.08-.6-2.32-1.63-7.47-1.63-7.47C48.24,438.92,66.65,438.67,78.2,432Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3,407.47A12.07,12.07,0,0,1,86.37,412a21.47,21.47,0,0,1-7.29,6.47c-12.61,7.28-33.06,7.28-45.66,0A21.38,21.38,0,0,1,26.13,412a12.4,12.4,0,0,1-1.93-4.51h0c-1.12-5.48,2-11.18,9.23-15.38,12.6-7.28,33.05-7.28,45.66,0C86.35,396.29,89.43,402,88.3,407.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.37,412a21.47,21.47,0,0,1-7.29,6.47c-12.61,7.28-33.06,7.28-45.66,0A21.38,21.38,0,0,1,26.13,412a12.4,12.4,0,0,1-1.93-4.51h0l1.43,9.84c.66,4,3.61,7.82,8.87,10.86,12,6.93,31.49,6.93,43.51,0,5.19-3,8.14-6.81,8.84-10.72l.08-.51,1.38-9.47A12.07,12.07,0,0,1,86.37,412Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.28,394.29c-10.51-6.07-27.55-6.07-38.05,0-5.95,3.43-8.52,8.07-7.75,12.55.6,3.44,3.19,6.78,7.75,9.41,10.5,6.07,27.54,6.07,38.05,0,4.55-2.63,7.13-6,7.73-9.4C83.8,402.36,81.22,397.72,75.28,394.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.26,411a18.05,18.05,0,0,0,6,5.25c10.5,6.07,27.54,6.07,38.05,0a18.11,18.11,0,0,0,6-5.25c-.08-3.64-2.51-7.25-7.31-10-9.77-5.64-25.6-5.64-35.35,0C33.77,403.75,31.34,407.37,31.26,411Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.26,399.7c-4.83-1.3-5.65-11.76-2.94-22.8,2.63-10.74,11.05-26.85,12.84-26.49s4,17.86,2.77,29.41C69.41,393.83,63.09,401,58.26,399.7Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.26,399.7c-4.83-1.3-5.65-11.76-2.94-22.8,2.63-10.74,11.05-26.85,12.84-26.49s4,17.86,2.77,29.41C69.41,393.83,63.09,401,58.26,399.7Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.61,365.89c.87,1.37,1.4,3.68,3.43,3.69,1.63,0,2.48-1.72,3.95-2.11a4,4,0,0,1,3.24,1l-.06-1.26a4.92,4.92,0,0,0-2.8-1A4,4,0,0,0,66,367.25c-.75.59-1.67,1.47-2.71,1s-1.51-2-2.11-2.94A3.69,3.69,0,0,0,59.93,364c-.14.29-.27.59-.4.89A2.72,2.72,0,0,1,60.61,365.89Zm5.73-4.32c.69-.33,1.09-1,1.63-1.53a2.33,2.33,0,0,1,2.49-.48l.08,0c0-.37-.09-.74-.14-1.1a3.43,3.43,0,0,0-.46-.11,2.74,2.74,0,0,0-2,.44c-.67.48-1,1.3-1.75,1.72-1.26.76-2.26-.62-2.64-1.65-.17-.47-.3-.94-.45-1.41l-.39.74c.09.33.17.66.27,1C63.4,360.57,64.68,362.36,66.34,361.57Zm-.16,14c-.88.54-1.62,1.44-2.64,1.73-2.49.71-3.06-3.13-4.64-4.27a3.35,3.35,0,0,0-2.26-.59c-.1.3-.2.59-.29.88a3,3,0,0,1,1.26,0,3.42,3.42,0,0,1,2.18,1.93c.79,1.43,1.8,3.47,3.8,3.07A6.32,6.32,0,0,0,65.9,377a4.17,4.17,0,0,1,3.36-.91,4.6,4.6,0,0,1,1.9,1c0-.38,0-.75.06-1.14a4.89,4.89,0,0,0-2.3-1A4.3,4.3,0,0,0,66.18,375.54ZM67.7,384a5,5,0,0,0-3.3.43c-1.15.57-2,1.68-3.19,2.14-2.63,1-3-2.81-5-3.75a3.88,3.88,0,0,0-2-.38c0,.3-.09.6-.12.89a3.22,3.22,0,0,1,.76,0,3.51,3.51,0,0,1,2.71,2.1c.93,1.73,2.16,3.14,4.28,2.1,1.14-.55,2-1.59,3.12-2.09a3.72,3.72,0,0,1,3.93.36,5.75,5.75,0,0,1,.73.9c.1-.37.19-.76.28-1.14A4.21,4.21,0,0,0,67.7,384Z",
    style: {
      fill: "#00539C",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.26,399.7c4.83,1.31,11.15-5.87,12.67-19.88a81.42,81.42,0,0,0,.27-12c-3.94,3.23-7.9,9.85-7.9,9.85a106.05,106.05,0,0,0-4.69-10.57,72.36,72.36,0,0,0-3.29,9.8C52.61,387.94,53.43,398.4,58.26,399.7Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.32,405.5c-6.35,4.08-12.27-10.42-15.43-21.36S37.8,344.58,41,343c2.26-1.11,14.26,24.53,16.61,37C59.32,389.05,59.38,402.26,54.32,405.5Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.32,405.5c-6.35,4.08-12.27-10.42-15.43-21.36S37.8,344.58,41,343c2.26-1.11,14.26,24.53,16.61,37C59.32,389.05,59.38,402.26,54.32,405.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.62,363.22c2,1,3.58,1,5.13-.69s2.52-3.54,4.77-3.29l-.66-1.49a3.37,3.37,0,0,0-1.09.11c-2,.53-2.86,2.58-4.24,3.87-2.13,2-4.4-.62-6.82-.48l-.22,0-.06,1.32A6.11,6.11,0,0,1,40.62,363.22Zm17.46,19.69a7.07,7.07,0,0,0-1-.3,3.78,3.78,0,0,0-3,.68c-1.92,1.41-2,4.54-5.12,3.72-2.36-.62-4.13-2.18-6.62-.94A9,9,0,0,0,40,387.79l.36,1.09a7.19,7.19,0,0,1,3.1-1.92c2.67-.68,4.69,2,7.35,1.58,2.17-.36,2.41-2.75,3.92-3.92a3.36,3.36,0,0,1,3.52-.22C58.2,383.89,58.14,383.4,58.08,382.91ZM40.73,352.83c.74,1,1.79,2.16,3.16,1.45s1.59-2.55,2.54-3.71l-.52-1c-.92,1.23-1.38,3.91-3.14,3.81-1.38-.07-1.92-2.12-3.07-2.71a2,2,0,0,0-1.15-.22c0,.28-.09.56-.13.84a2.44,2.44,0,0,1,.27,0C39.65,351.32,40.22,352.13,40.73,352.83Zm4.78,21.72c2.51.54,3.74-2.44,4.87-4.1a7.4,7.4,0,0,1,3.48-2.94l-.51-1.35a4.65,4.65,0,0,0-1.31.48,8.57,8.57,0,0,0-2.72,2.77c-.76,1.12-1.38,2.64-2.55,3.4-1.34.87-2.92-.49-4.31-.75a7.45,7.45,0,0,0-3.86.32,6.1,6.1,0,0,0-1.18.57c0,.62.06,1.23.1,1.83a6,6,0,0,1,4.07-1.37C43.06,373.44,44.14,374.26,45.51,374.55Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.28,368.66a36,36,0,0,0-5.14,8.43s-6.9-9.35-11.74-13.59c-.27,7.77.12,15.88,1.49,20.64,3.16,10.94,9.08,25.44,15.43,21.36,5.06-3.24,5-16.45,3.29-25.47A77.57,77.57,0,0,0,54.28,368.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.89,413c-11.62.63-22.47-6.4-29.51-15.27s-12.54-27.18-10.95-28.31,20.33,10.43,27.37,18.77C50,399.08,53.89,413,53.89,413Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.89,413c-11.62.63-22.47-6.4-29.51-15.27s-12.54-27.18-10.95-28.31,20.33,10.43,27.37,18.77C50,399.08,53.89,413,53.89,413Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.54,383.87c.68-1.1.29-2.42.14-3.6a3.27,3.27,0,0,1,.47-2.25l-1.31-.93a4.7,4.7,0,0,0-.48,3.15c.2,1.34.52,3-1.27,3.26-2,.26-4.66-1.48-6.23.45-.75.94-.47,2.13-.49,3.23a3.1,3.1,0,0,1-.42,1.41c.21.45.42.88.64,1.32a4,4,0,0,0,.87-2c.16-1.35-.37-3.09,1.46-3.38,1.26-.2,2.47.38,3.72.47A3,3,0,0,0,28.54,383.87Zm-6.48-9.7a2.24,2.24,0,0,1,.51-.55L21.52,373c-.85,1.12-.85,2.66-1.71,3.77a2,2,0,0,1-2.19.62,3.72,3.72,0,0,0-2.42.09,4.67,4.67,0,0,0-.49.27l.27.85a2.55,2.55,0,0,1,1.22-.34c.87,0,1.69.44,2.58.38a2.32,2.32,0,0,0,1.54-.79C21.27,376.78,21.32,375.32,22.06,374.17Zm12.87,15.56a5.79,5.79,0,0,0,1.76-3,22,22,0,0,0,.3-2.46l-1.1-1c-.24,1.37-.11,2.74-.81,4a3.64,3.64,0,0,1-3.62,1.89,3.79,3.79,0,0,0-3.1,1,5.84,5.84,0,0,0-1.16,3.12c-.24,1.61-.49,3.11-2,4a4.48,4.48,0,0,1-.8.38c.27.34.56.68.84,1a4.73,4.73,0,0,0,1.67-1.24c1.94-2.3.36-6.88,4.49-6.88A5,5,0,0,0,34.93,389.73Zm6.24,1.17a6.09,6.09,0,0,1,.87-1.21c-.32-.42-.66-.84-1-1.25a7.5,7.5,0,0,0-1.86,3.65c-.36,1.48-.55,3.09-1.52,4.33s-2.61,1.16-3.95,1.9a5.66,5.66,0,0,0-2.48,2.89,13.89,13.89,0,0,0-.62,2.93l1.23,1a1.22,1.22,0,0,0,0-.17c.27-1.65.46-3.34,1.74-4.54s2.92-1,4.23-1.91C40.35,396.76,39.91,393.37,41.17,390.9Zm5,4.84a8.57,8.57,0,0,0-.94.87c-2,2.18-1.73,5-2.46,7.67a4.72,4.72,0,0,1-2.47,3.32c-1.11.45-2.36,0-3.32.88a1.09,1.09,0,0,0-.1.11q.87.5,1.74.93a5.34,5.34,0,0,1,1-.11,4.54,4.54,0,0,0,1.81-.43,5.15,5.15,0,0,0,2.21-2.42c1.2-2.49.66-5.53,2.17-7.9a6.3,6.3,0,0,1,1.26-1.45Q46.65,396.48,46.2,395.74Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.73,377C28.82,386.63,34,412.51,53.89,413c0,0-3.86-13.88-13.09-24.81C37.81,384.61,32.73,380.5,27.73,377Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.89,413c-9.14-1.33-17-7.12-21-24.33s-4.64-25-1.87-26.69c3.19-2,15.66,15.38,19.67,23C60.75,404.12,53.89,413,53.89,413Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.94,381.16c2.27.72,5.24,1.48,7-.77.83-1.1,1.06-2.59,1.64-3.75-.4-.59-.81-1.17-1.22-1.76-1,1.62-1,4-2.74,4.94-1.33.7-2.9.24-4.23-.16a9.89,9.89,0,0,0-4.2-.63,5.84,5.84,0,0,0-2.19.77c.1.5.21,1,.32,1.56a7.7,7.7,0,0,1,.92-.43A7,7,0,0,1,36.94,381.16Zm-2.7-8.91a3.67,3.67,0,0,0,2.12.41c1.39-.29,2.11-1.63,2.82-2.72a6.19,6.19,0,0,1,.7-.9c-.28-.35-.57-.7-.85-1l-.18.17c-.86,1.05-1.59,3.18-3.2,3.21a11.15,11.15,0,0,1-2.28-.66,5.22,5.22,0,0,0-2,0,4.84,4.84,0,0,0-1.82.69c0,.4.1.81.15,1.24a5.49,5.49,0,0,1,2.45-.76A5,5,0,0,1,34.24,372.25Zm10,19.12c.87-1.28,1.5-2.72,2.79-3.64a6.1,6.1,0,0,1,4.66-.83c-.31-.64-.63-1.28-1-1.94a7.72,7.72,0,0,0-3.16.2A6.68,6.68,0,0,0,44,387.71a20.26,20.26,0,0,1-2.34,3.37c-1.86,1.7-4.37.21-6.45-.2a7.49,7.49,0,0,0-1.82-.14c.16.6.32,1.18.49,1.75a8,8,0,0,1,2.4.37C39.43,393.83,42.13,394.4,44.21,391.37Zm10.52,3.34c-.15.05-.3.08-.46.14a7.1,7.1,0,0,0-3.09,2.32c-.89,1.14-1.36,2.53-2.19,3.7a2.87,2.87,0,0,1-3.64,1.21,6.25,6.25,0,0,0-4-.29,6.58,6.58,0,0,0-2.54,1.59c.31.46.63.89,1,1.31a5.74,5.74,0,0,1,2-1.14,4.4,4.4,0,0,1,3.14.39,4.93,4.93,0,0,0,6.47-2c.78-1.15,1.23-2.51,2.11-3.58A5,5,0,0,1,55.32,397C55.15,396.23,55,395.49,54.73,394.71Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.68,385C50,383.57,49,381.87,47.77,380c-4,12.21-5.22,30,6.12,32.93C53.89,413,60.75,404.12,50.68,385Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.61,413c11.61.63,22.47-6.4,29.51-15.27s12.54-27.18,10.95-28.31S78.74,379.81,71.7,388.15C62.47,399.08,58.61,413,58.61,413Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.61,413c11.61.63,22.47-6.4,29.51-15.27s12.54-27.18,10.95-28.31S78.74,379.81,71.7,388.15C62.47,399.08,58.61,413,58.61,413Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.86,385c1.25-.09,2.46-.67,3.72-.47,1.82.29,1.29,2,1.46,3.38a4,4,0,0,0,.87,2c.22-.44.43-.87.64-1.32a3.1,3.1,0,0,1-.42-1.41c0-1.1.26-2.29-.5-3.23-1.56-1.93-4.26-.19-6.22-.45-1.79-.25-1.47-1.92-1.28-3.26a4.7,4.7,0,0,0-.47-3.15l-1.31.93a3.32,3.32,0,0,1,.47,2.25c-.15,1.18-.54,2.5.14,3.6A3,3,0,0,0,86.86,385Zm5.32-7.2a2.32,2.32,0,0,0,1.54.79c.89.06,1.7-.4,2.58-.38a2.59,2.59,0,0,1,1.22.34l.27-.85a4.67,4.67,0,0,0-.49-.27,3.72,3.72,0,0,0-2.42-.09,2,2,0,0,1-2.19-.62c-.86-1.11-.86-2.65-1.72-3.77l-1,.64a2.24,2.24,0,0,1,.51.55C91.18,375.32,91.23,376.78,92.18,377.83ZM81.09,390.61c4.13,0,2.55,4.58,4.49,6.88a4.65,4.65,0,0,0,1.67,1.24c.28-.33.57-.67.84-1a4.48,4.48,0,0,1-.8-.38c-1.51-.91-1.75-2.41-2-4a5.84,5.84,0,0,0-1.16-3.12,3.8,3.8,0,0,0-3.1-1,3.64,3.64,0,0,1-3.62-1.89c-.7-1.28-.57-2.65-.81-4l-1.1,1a18.17,18.17,0,0,0,.3,2.46,5.72,5.72,0,0,0,1.76,3A5,5,0,0,0,81.09,390.61Zm-6.44,7.92c1.32.92,3,.75,4.23,1.91s1.48,2.89,1.74,4.54c0,0,0,.11,0,.17l1.23-1a13.31,13.31,0,0,0-.63-2.93,5.6,5.6,0,0,0-2.47-2.89c-1.34-.74-3-.6-4-1.9s-1.15-2.85-1.51-4.33a7.5,7.5,0,0,0-1.86-3.65c-.34.41-.68.83-1,1.25a6.09,6.09,0,0,1,.87,1.21C72.59,393.37,72.15,396.76,74.65,398.53Zm-9.22-1.32a6.54,6.54,0,0,1,1.26,1.45c1.5,2.37,1,5.41,2.17,7.9A5.15,5.15,0,0,0,71.07,409a4.54,4.54,0,0,0,1.81.43,5.13,5.13,0,0,1,1,.11q.89-.43,1.74-.93a.48.48,0,0,0-.09-.11c-1-.87-2.21-.43-3.32-.88a4.72,4.72,0,0,1-2.47-3.32c-.73-2.67-.48-5.49-2.46-7.67a7.84,7.84,0,0,0-.95-.87C66,396.23,65.71,396.72,65.43,397.21Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.77,377c-1.1,9.61-6.23,35.49-26.16,35.94,0,0,3.86-13.88,13.09-24.81C74.68,384.61,79.77,380.5,84.77,377Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.61,413c9.14-1.33,17-7.12,21-24.33s4.65-25,1.88-26.69c-3.19-2-15.66,15.38-19.67,23C51.74,404.12,58.61,413,58.61,413Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.31,380.93a7.7,7.7,0,0,1,.92.43c.1-.52.22-1.06.32-1.56a5.84,5.84,0,0,0-2.19-.77,9.89,9.89,0,0,0-4.2.63c-1.34.4-2.9.86-4.23.16-1.76-.92-1.73-3.32-2.74-4.94-.41.59-.82,1.17-1.22,1.76.58,1.16.81,2.65,1.64,3.75,1.71,2.25,4.67,1.49,7,.77A7,7,0,0,1,80.31,380.93Zm0-9.07a5.49,5.49,0,0,1,2.45.76c0-.43.11-.84.15-1.24a4.83,4.83,0,0,0-1.83-.69,5.17,5.17,0,0,0-2,0,11.15,11.15,0,0,1-2.28.66c-1.61,0-2.34-2.16-3.2-3.21l-.18-.17-.86,1a5.63,5.63,0,0,1,.71.9c.7,1.09,1.43,2.43,2.82,2.72a3.67,3.67,0,0,0,2.12-.41A5,5,0,0,1,80.32,371.86Zm-4.15,21a8.08,8.08,0,0,1,2.41-.37c.17-.57.33-1.15.49-1.75a7.49,7.49,0,0,0-1.82.14c-2.08.41-4.59,1.9-6.45.2a19.68,19.68,0,0,1-2.34-3.37A6.67,6.67,0,0,0,65,385.16a7.67,7.67,0,0,0-3.15-.2c-.35.66-.67,1.3-1,1.94a6.1,6.1,0,0,1,4.66.83c1.29.92,1.92,2.36,2.79,3.64C70.36,394.4,73.07,393.83,76.17,392.86Zm-19,4.09a5,5,0,0,1,1.89,1.45c.87,1.07,1.33,2.43,2.11,3.58a4.92,4.92,0,0,0,6.46,2,4.43,4.43,0,0,1,3.15-.39,5.74,5.74,0,0,1,2,1.14c.32-.42.64-.85.95-1.31a6.54,6.54,0,0,0-2.55-1.59,6.22,6.22,0,0,0-4,.29,2.87,2.87,0,0,1-3.64-1.21c-.83-1.17-1.3-2.56-2.19-3.7a7.1,7.1,0,0,0-3.09-2.32c-.16-.06-.31-.09-.46-.14C57.54,395.49,57.35,396.23,57.18,397Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.82,385c.73-1.38,1.73-3.08,2.91-4.92,4,12.21,5.22,30-6.12,32.93C58.61,413,51.74,404.12,61.82,385Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.25,414.86c7.71,0,10.27-10.49,9.5-18.93s-6.11-24.51-9.5-24.51-8.73,16.06-9.5,24.51S48.54,414.86,56.25,414.86Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.25,414.86c7.71,0,10.27-10.49,9.5-18.93s-6.11-24.51-9.5-24.51-8.73,16.06-9.5,24.51S48.54,414.86,56.25,414.86Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2,382.41c1.23-.25,2-1.25,2.87-2.05a5,5,0,0,1,2.38-1.24c-.19-.5-.39-1-.6-1.45a7.3,7.3,0,0,0-3.25,2,4.42,4.42,0,0,1-1.61,1.2c-.93.33-1.5-.17-2.11-.78a5.09,5.09,0,0,0-2.53-1.52h-.08c-.16.4-.32.8-.48,1.22a4.78,4.78,0,0,1,2.69,1.51A2.88,2.88,0,0,0,56.2,382.41Zm-5.75,9.25c2.57,2,4.69-.85,6.33-2.54,1.38-1.42,2.82-1.71,4.39-.4a10.16,10.16,0,0,0,2.93,2.12,4.2,4.2,0,0,0,.88.22c-.09-.48-.2-1-.31-1.45a8.82,8.82,0,0,1-3.13-2.09c-2.29-1.88-4.36-1.09-6.18,1-1,1.2-2.74,3.27-4.46,2-1-.76-1.5-2.05-2.56-2.78l0,0c-.11.43-.21.85-.31,1.27C49,389.62,49.5,390.91,50.45,391.66Zm2.88,9.23c1.46,1.93,3.27,2.41,5.25.75,1-.8,1.59-1.95,2.64-2.66,1.46-1,3.14-.48,4.65.12,0-.46,0-.92,0-1.37a10.44,10.44,0,0,0-2.14-.67,4.3,4.3,0,0,0-3.31.67c-1.09.78-1.76,2-2.82,2.8a2.58,2.58,0,0,1-2.22.71c-.88-.33-1.41-1.42-2-2.08a6.47,6.47,0,0,0-3-1.7,5.47,5.47,0,0,0-3.69.37c0,.43,0,.87,0,1.31A5.43,5.43,0,0,1,53.33,400.89Zm7.31,7.86a6.08,6.08,0,0,1-4.35,1.3,3.46,3.46,0,0,1-2.19-1c-.42-.43-.73-1-1.17-1.41a5.06,5.06,0,0,0-2.9-1.43,5.59,5.59,0,0,0-2.41.2c.13.47.28.93.44,1.38a4,4,0,0,1,3.84.53c.92.69,1.37,1.82,2.35,2.46a5.52,5.52,0,0,0,3,.78,7,7,0,0,0,3.2-.79c1.1-.59,1.89-1.59,3-2.21a5.49,5.49,0,0,1,.89-.4c.21-.56.4-1.15.57-1.75a5.5,5.5,0,0,0-1.08.23A10.8,10.8,0,0,0,60.64,408.75Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Key--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--key--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.73,393.61c-14.46-8.28-37.86-8.19-52.26.19-6,3.51-9.82,5.87-10.77,10.42v4.71a14.91,14.91,0,0,0,4.53,10.17L201.58,452l0,4.7,7.27,4.16,20.26-.07,7.94-4.63v-4.44l6.33-3.57,8.83-.81,3.51-2,.32-7.89,6.52-3.79,9.57,2.13,12.42-7.23c13.41,3.16,29.41,1.57,40.28-4.76,7.22-4.21,10.81-9.7,10.77-15.17l0-4.66C334.92,399.06,331.23,397.33,324.73,393.61Zm-9,13.52a16.35,16.35,0,0,1-14.8.06c-4.1-2.35-4.11-6.18,0-8.55a16.32,16.32,0,0,1,14.8-.05C319.83,400.93,319.84,404.76,315.76,407.13Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.73,393.61c-14.46-8.28-37.86-8.19-52.26.19-6,3.51-9.82,5.87-10.77,10.42v4.71a14.91,14.91,0,0,0,4.53,10.17L201.58,452l0,4.7,7.27,4.16,20.26-.07,7.94-4.63v-4.44l6.33-3.57,8.83-.81,3.51-2,.32-7.89,6.52-3.79,9.57,2.13,12.42-7.23c13.41,3.16,29.41,1.57,40.28-4.76,7.22-4.21,10.81-9.7,10.77-15.17l0-4.66C334.92,399.06,331.23,397.33,324.73,393.61Zm-9,13.52a16.35,16.35,0,0,1-14.8.06c-4.1-2.35-4.11-6.18,0-8.55a16.32,16.32,0,0,1,14.8-.05C319.83,400.93,319.84,404.76,315.76,407.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.71,388.91c-14.46-8.28-37.86-8.2-52.26.19-11.83,6.89-13.89,17.23-6.23,25.3L201.58,452l7.28,4.16,20.25-.07,7.95-4.63-.56-4.14,6.87-3.87,8.83-.81,3.51-2,.33-7.89,6.51-3.79,9.57,2.12,12.42-7.23C298,427,314,425.41,324.82,419.08,339.22,410.7,339.17,397.19,324.71,388.91Zm-9,13.52a16.34,16.34,0,0,1-14.81.05c-4.09-2.34-4.11-6.17,0-8.54a16.37,16.37,0,0,1,14.81-.06C319.81,396.23,319.83,400.05,315.75,402.43Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.71,388.91c-14.46-8.28-37.86-8.2-52.26.19-11.83,6.89-13.89,17.23-6.23,25.3L201.58,452l7.28,4.16,20.25-.07,7.95-4.63-.56-4.14,6.87-3.87,8.83-.81,3.51-2,.33-7.89,6.51-3.79,9.57,2.12,12.42-7.23C298,427,314,425.41,324.82,419.08,339.22,410.7,339.17,397.19,324.71,388.91Zm-9,13.52a16.34,16.34,0,0,1-14.81.05c-4.09-2.34-4.11-6.17,0-8.54a16.37,16.37,0,0,1,14.81-.06C319.81,396.23,319.83,400.05,315.75,402.43Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.81,405.59l36.44-5.75c-1-2-.1-4.3,2.66-5.9a16.37,16.37,0,0,1,14.81-.06,6.36,6.36,0,0,1,2.74,2.77l13.3-2.1a26.5,26.5,0,0,0-7.05-5.64c-.42-.24-.87-.45-1.3-.68l-60,9.46A13.12,13.12,0,0,0,261.81,405.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.53,411a13,13,0,0,0,.11-13.87l-15.14,2.38a6.16,6.16,0,0,1-2.75,2.88,16.34,16.34,0,0,1-14.81.05l-.2-.12-38.29,6a16.81,16.81,0,0,0,3.77,6l-17.12,10Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.7,421.18c-9.14,0-17.67-2-24-5.6-5.54-3.17-8.72-7.31-8.74-11.37s3.14-8.23,8.66-11.44c6.33-3.69,14.85-5.73,24-5.77s17.67,2,24,5.6c5.54,3.17,8.73,7.32,8.74,11.37s-3.14,8.23-8.66,11.44C316.35,419.1,307.83,421.14,298.7,421.18Zm-.12-32.85c-8.91,0-17.19,2-23.32,5.59-5.1,3-8,6.71-8,10.28s2.95,7.3,8.07,10.23c6.16,3.53,14.46,5.45,23.36,5.42s17.19-2,23.32-5.59c5.1-3,8-6.71,8-10.28s-2.95-7.3-8.07-10.23C315.78,390.22,307.48,388.3,298.58,388.33Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,423.94l0,4.7a62.71,62.71,0,0,1-27.47-.09l0-4.7A62.71,62.71,0,0,0,312,423.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.12 431.07 272.14 435.78 262.57 433.65 262.55 428.95 272.12 431.07",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.04 432.74 256.05 437.44 255.73 445.33 255.71 440.63 256.04 432.74",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.2 442.67 252.22 447.37 243.39 448.18 243.37 443.48 252.2 442.67",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.87,
    y: 456.15,
    width: 20.25,
    height: 4.7,
    transform: "translate(-1.67 0.8) rotate(-0.21)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.58 452.03 201.6 456.73 208.87 460.89 208.86 456.19 205.67 454.36 205.68 456.39 203.92 455.39 203.91 453.33 201.58 452.03",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.91 453.33 205.67 454.36 205.68 456.39 203.92 455.39 203.91 453.33",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.91 453.33 205.67 454.36 205.68 456.39 203.92 455.39 203.91 453.33",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.91 453.33 203.92 455.39 270.2 416.79 268.44 415.76 203.91 453.33",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.44 415.76 268.45 417.81 270.2 416.79 268.44 415.76",
    style: {
      opacity: 0.15
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.14,321.72c-.39,11.31.63,22.07,0,28.68-.06.61,4.09,3.71,8.21,3.29s5.31-1.81,5.34-2.25c.1-1.53,1.66-3.61,1.84-5.13a197.08,197.08,0,0,1,4.29-23.51Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.79,327.6,434.13,326c1.95,9.57,4,19.5,5.5,26.21a37.39,37.39,0,0,0,1.68,5.92c.89,4.32,11,4.84,13-2.07l-.43-5.89C453.62,344.72,453.15,335.7,452.79,327.6Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.38,370.16c-.26,0-.65,2.93.75,4.17,1.62,1.44,6.36,3.8,12.63,3s8-2.12,10.54-4.28,4.81-4.43,7.65-5.08c2.63-.59,6.65-1.68,7.49-2.52s.73-4.56.73-4.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.77,344.7a1.11,1.11,0,0,1,1.06.89c.19,1,.4,4,.81,5.7a43.09,43.09,0,0,1,.41,10.84c-.35,1.91-5.79,3.09-8.54,4.17a26,26,0,0,0-7.68,5,19,19,0,0,1-11.59,4.36c-4.84,0-10.28-1.65-11.53-4-1.54-2.85-1.77-5.59,5.4-9,1.36-.65,5.54-3.17,7.17-4.23a30.76,30.76,0,0,0,5-3.9,25.9,25.9,0,0,0,1.84-1.94,6.29,6.29,0,0,0,1-2.09,28.36,28.36,0,0,0,.47-4.24.75.75,0,0,1,.13-.36.67.67,0,0,1,.32-.2,8.19,8.19,0,0,1,3.52-.19,14,14,0,0,1,3.53.83,2.92,2.92,0,0,1,1.63,1.06,2.7,2.7,0,0,1,.31,1.38,11.33,11.33,0,0,0,0,1.43.89.89,0,0,0,.19.47c.24.25.63.05.84-.15a19.29,19.29,0,0,0,1.93-2.38c.34-.44,1.86-.71,2.29-1.05a13.14,13.14,0,0,0,1.23-.82C403,345.86,402.75,345.29,402.77,344.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.83,371.3a34.63,34.63,0,0,1,3.33-2.63h0s-7.64,3.11-11.05.71c-2.2-1.54-1.15-3.41-1.1-4s-5.36-3.17-7.49-3.43h0c-.6.34-1.1.61-1.41.76-7.17,3.42-6.94,6.16-5.4,9,1.25,2.31,5.19,4.11,11.44,4.11A19.56,19.56,0,0,0,388.83,371.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.6,363.61c-4.46,1.84-2.56,2.69-1.31,2.88s7.54-3.55,12.12-7.27c4.78-3.89,8.94-8,10.72-9.42.66-.54,1.37-1.19,2-1.8-.11-1-.21-1.93-.3-2.41a1.61,1.61,0,0,0-1.15-1.12l-.15,1.84a3.45,3.45,0,0,1-1.3.68,5.66,5.66,0,0,0-2.22,1.19,19.29,19.29,0,0,1-1.93,2.38C393.18,355.65,385.06,361.78,380.6,363.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.61,365.81a.42.42,0,0,0,.28-.1.46.46,0,0,0,.06-.64,10.49,10.49,0,0,0-8.17-3.32.46.46,0,0,0-.39.5.44.44,0,0,0,.49.41,9.68,9.68,0,0,1,7.39,3A.41.41,0,0,0,379.61,365.81Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.51,363.55a.39.39,0,0,0,.28-.09.47.47,0,0,0,.07-.64,10.49,10.49,0,0,0-8.09-3.51.46.46,0,0,0,.08.91,9.72,9.72,0,0,1,7.32,3.16A.42.42,0,0,0,383.51,363.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.11,361a.45.45,0,0,0,.28-.11.47.47,0,0,0,.06-.64,10.46,10.46,0,0,0-8.17-3.31.44.44,0,0,0-.39.5.43.43,0,0,0,.48.4,9.69,9.69,0,0,1,7.4,3A.42.42,0,0,0,387.11,361Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.29,358.66a.37.37,0,0,0,.28-.09.46.46,0,0,0,.09-.63,10.49,10.49,0,0,0-8-3.67.45.45,0,0,0-.42.48.44.44,0,0,0,.47.42,9.73,9.73,0,0,1,7.26,3.31A.43.43,0,0,0,390.29,358.66Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.71,355.92a.42.42,0,0,0,.28-.08.47.47,0,0,0,.09-.64c-1.64-2.31-5.5-3.95-8.79-3.71a.46.46,0,0,0-.41.49.45.45,0,0,0,.47.42c3-.21,6.56,1.29,8,3.34A.41.41,0,0,0,393.71,355.92Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.43,381.63c.31,4.46,1,7.41,2.6,10s4.49,3.38,7.43,2.57,6.67-2.91,7.46-6.78.59-6.5-.13-10.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.88,350.15c1,.33,1.37,6.43,2.15,12.43.83,6.42,2,8.35,2.7,13.61.85,6,.46,8-1.54,11.72s-9.23,7.35-12.88,2.18c-3-4.21-3.05-8.26-2.86-14.28a129.9,129.9,0,0,0-.24-14.34c-.3-4.51-2.62-8.77-1.58-9.28a17.68,17.68,0,0,0,.77,3.37,5.71,5.71,0,0,0,.66,1.66c.58.84.84-.54.83-1.06,0-.89-.31-1.6.36-2.35a4.94,4.94,0,0,1,1.79-1.09,10.76,10.76,0,0,1,2.2-.68,22.21,22.21,0,0,1,4.68-.34,2.21,2.21,0,0,1,1.81.75,1.35,1.35,0,0,1,.18.47c.13.59.07,1.2.2,1.79,0,.16.1.59.25.69s.41.05.42-.07S454,351.2,453.88,350.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.45,374.13c.13.87.79,6.29-.72,7.35s-2.6-3.36-2.6-3.36-3.89-1.17-9.48,1.45c.3.93-.53,4-2.08,3.39s-2.13-6.54-2.14-6.63c-.16,5.78,0,9.67,2.88,13.76,3.65,5.17,10.87,1.49,12.88-2.18s2.39-5.7,1.54-11.72C458.65,375.59,458.57,374.68,458.45,374.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.69,378.51c.06,2.18,1.94,1.4,2.19-1.67.37-4.6-.8-9-.85-14.26-.78-6-.94-12.35-2.15-12.43.06,1-.1,5.18-.1,5.18.44,4.49,1.65,9.72,1.54,14.36C455.22,373.77,454.64,376.33,454.69,378.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.3,379.5c-.43-2.14-1.11-2.74-1.59-6.79S442,361.42,441.08,357c-.24-1.35-1.44-4.81-1.45-4.85-.75.38,0,2.9.64,5.6s1.05,4.37,1.47,7c1.11,5.17,1.33,10.68,2.06,13.67S446.73,381.63,446.3,379.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.82,379.61a.43.43,0,0,0,.16-.05,14,14,0,0,1,9.33-1.13.46.46,0,0,0,.55-.34.47.47,0,0,0-.33-.56,14.72,14.72,0,0,0-10,1.21.48.48,0,0,0-.18.63A.45.45,0,0,0,445.82,379.61Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.54,375.3l.15,0c.05,0,5.4-2.65,10.88-1.43a.47.47,0,0,0,.54-.36.47.47,0,0,0-.35-.55,19,19,0,0,0-11.47,1.51.46.46,0,0,0-.21.62A.46.46,0,0,0,444.54,375.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.14,370.28a.45.45,0,0,0,.38-.32.46.46,0,0,0-.29-.58c-5.46-1.82-12.57.9-12.8,1a.47.47,0,0,0-.18.63.45.45,0,0,0,.61.18c.05,0,7-2.66,12.09-1A.43.43,0,0,0,456.14,370.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.21,366.39a.47.47,0,0,0,.38-.31.47.47,0,0,0-.28-.59c-6-2.12-12.11,1.34-12.32,1.48a.46.46,0,0,0-.14.63.44.44,0,0,0,.62.15s5.95-3.35,11.54-1.38A.47.47,0,0,0,455.21,366.39Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.78,361.64a.47.47,0,0,0,.37-.31.47.47,0,0,0-.27-.59c-5.63-2.08-12.17,1.46-12.39,1.6a.47.47,0,0,0-.16.64.43.43,0,0,0,.61.16c.06,0,6.41-3.46,11.64-1.53A.44.44,0,0,0,454.78,361.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.78,250.54l-4.64,28.86a92.89,92.89,0,0,1,1,17c-.41,8.33-5.26,33.11-7,41.94-9.21,5.6-17.65-.42-17.65-.42s-2.41-48.42-3.13-60.11,1-59.07,1.54-77.6l59.12.17s1.1,10,2.08,24.86S449.32,280,449.32,280c6,17.71,3.49,29.34,4.54,62.42a16.3,16.3,0,0,1-16.38,2s-8.7-32.49-12.05-45.67c-1.6-6.29-7.41-33.64-10.65-48.16",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.73,229.08l-1.59,22.72c-.1,3.63-.89,11.58-.95,15.21s-.17,7.26,0,10.83,1.85,33,1.57,40.3c-1-8.07-2.76-32.92-3.2-40.22-.18-7.35.64-15.67,1.59-26.21S390.83,236.3,391.73,229.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.47,225.19c2.77,11.92,7.32,42.72,8.36,51s8.67,40.74,9.45,49.05c-1.41-8.23-10-40.54-11.07-48.83S426.2,240.28,424.47,225.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.05,228l4.73,22.56-4.64,28.86,1.92-24.14-5.14-24.68s-9.65-2.94-12.17-13C399.67,225.67,410.05,228,410.05,228Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.76,128c-5.44.89-10.76,3.64-14.88,11.83-3.38,6.74-4.16,12.58-9.49,23.23l-22.31-.36,4,14.25s13.3,2.36,20.18,2.91c5.15.41,7.22-1,10.35-5.16,4.08-5.49,9.78-18.35,9.78-18.35Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.09,127.69c-3.23.52-8.3,2.14-11.17,5.57s-5.44,8.2-8,15.82-3.07,9.12-3.07,9.12,2.56,3.13,8.53,5.18,8.75,1.26,8.75,1.26l5-17.24Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-43",
    d: "M425.39,125.6c9,2,12.9,2.91,17.17,3.91,0,0,7.29,15.07,3.47,30.75-.88,3.61-1.34,14.32-1.94,22-.5,6.31,0,15.23.69,24.21,0,0-12.79,8.24-38,5.65-19.81-2-22.19-9.4-22.19-9.4s1.2-28.24,1.06-42.89c-.2-19.49,7.24-29.52,9.47-32.13.71-.41,14.16-2.44,14.16-2.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-43",
    d: "M409.31,126.27l16,.34c8.51,1.91,12.39,2.8,16.57,3.77,1.12,2.55,6.55,15.94,3.21,29.64-.66,2.68-1.08,9.06-1.49,15.22-.15,2.35-.31,4.79-.48,6.93-.5,6.3,0,15.1.64,23.73-2.19,1.21-11.45,5.7-27.39,5.7a93,93,0,0,1-9.47-.49c-17.25-1.77-20.82-7.65-21.28-8.59.11-2.71,1.19-28.89,1.05-42.71-.18-18.46,6.66-28.37,9.06-31.26,1.31-.35,7.8-1.41,13.62-2.28m-.06-1s-13.45,2-14.16,2.44c-2.23,2.61-9.67,12.64-9.47,32.13.14,14.65-1.06,42.89-1.06,42.89s2.38,7.38,22.19,9.4a94.46,94.46,0,0,0,9.58.51c18.89,0,28.45-6.16,28.45-6.16-.67-9-1.19-17.9-.69-24.21.6-7.67,1.06-18.38,1.94-22,3.82-15.68-3.47-30.75-3.47-30.75-4.27-1-8.14-1.88-17.17-3.91l-16.14-.35Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.73,90.67c-1.2-2.72-2.79-4-3.81-4.41a11.87,11.87,0,0,0-8-10.69,23.35,23.35,0,0,0-9.67-.83c-3.14.26-6.55.73-9.22-.93a.55.55,0,0,0-.34-.13.51.51,0,0,0-.22.11,2,2,0,0,0-.55,2.11,4.22,4.22,0,0,0,1.33,1.86,12.51,12.51,0,0,0-10.18,6.81,11.43,11.43,0,0,0-.32,5.58,3.17,3.17,0,0,1,2.35-2.27c-.33.07-.56,1.89-.59,2.19a7.88,7.88,0,0,0,.11,2.42c.22,1,.78,3.22,1.72,3.83s2.36.22,3.34.15l5.82-.46,12.59-1,3.26-.25a14,14,0,0,0-.13,4.13c.41,3.71,4.61,7.43,4.61,7.43l-.21,5.16-.1,7.41a4.79,4.79,0,0,0,2.74-2.25,39,39,0,0,0,4.5-10.68C434.29,96.31,433.93,93.39,432.73,90.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.43,111.93c-3.81,1.91-5.6-1.1-5.6-1.1l-.38,16.63c-7.24,9.94-26.94,6.22-19-1.26l0-4.68a28.15,28.15,0,0,1-3.32-.32c-3.41-.49-5.57-2.88-6.63-6.54-1.56-5.43-2.26-14.13-.32-23.42.37-1.79,1.12-3.75,2.75-4.58,4.05-2.07,7.86.79,13.56,2.93,2.36.89,8.07,1.22,9.57.5-2,2.21-.74,7.86-.19,9.65.79,2.57,1.9,3.82,2.44,3.93,2.33.45,2.58-1.54,3.61-2.65a4.27,4.27,0,0,1,6.67,1.45A7,7,0,0,1,431.43,111.93Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.9,116.94c-.75,3.77-5.81,6.31-14.43,6.62l0-2a40.15,40.15,0,0,0,6.32-.65C416.8,120.15,420.9,116.94,420.9,116.94Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.33,95.63l3.77,1.59A2.16,2.16,0,0,0,415,94.47,2,2,0,0,0,412.33,95.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.14,96.69l3.94-1.19a2,2,0,0,0-2.5-1.41A2.15,2.15,0,0,0,398.14,96.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.73,99.67a1.67,1.67,0,1,1-1.62-1.7A1.66,1.66,0,0,1,414.73,99.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.18,99.51a1.67,1.67,0,1,1-3.33-.08,1.66,1.66,0,0,1,1.7-1.62A1.51,1.51,0,0,1,402.18,99.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.41,97.62l-1.58,9.9-5.12-1.22A19.75,19.75,0,0,1,407.41,97.62Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.36,108.75,405.62,111a3,3,0,0,0,3.94,1.87A3.22,3.22,0,0,0,411.36,108.75Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.8,109.83a3.15,3.15,0,0,1,.74-.11,3.19,3.19,0,0,1-2,3.12,3,3,0,0,1-1,.18A2.81,2.81,0,0,1,410.8,109.83Z",
    style: {
      fill: "#f28f8f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tablet--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.18,142.35h0l1.46-1v0a1.51,1.51,0,0,1,1.37,0l37.44,15.35a5.27,5.27,0,0,1,2.84,3.38L392.9,191a1.33,1.33,0,0,1-.37,1.48h0l-1.5,1v0a1.44,1.44,0,0,1-1.38,0L352.21,178.1a5.29,5.29,0,0,1-2.84-3.39c-1.3-6.06-5.33-24.77-6.64-30.83C342.57,143.12,342.76,142.58,343.18,142.35Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.18,142.35h0l1.46-1v0a1.51,1.51,0,0,1,1.37,0l37.44,15.35a5.27,5.27,0,0,1,2.84,3.38L392.9,191a1.33,1.33,0,0,1-.37,1.48h0l-1.5,1v0a1.44,1.44,0,0,1-1.38,0L352.21,178.1a5.29,5.29,0,0,1-2.84-3.39c-1.3-6.06-5.33-24.77-6.64-30.83C342.57,143.12,342.76,142.58,343.18,142.35Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.42,158.73a5.22,5.22,0,0,1,1.39,2.38l6.64,30.83a1.42,1.42,0,0,1-.32,1.46l1.41-.94h0a1.35,1.35,0,0,0,.38-1.49l-6.64-30.84a5,5,0,0,0-1.27-2.24Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.44,191.94,384.8,161.1a5.31,5.31,0,0,0-2.83-3.38l-37.45-15.34c-1.28-.52-2.08.15-1.79,1.5,1.31,6.06,5.34,24.77,6.64,30.83a5.29,5.29,0,0,0,2.84,3.39l37.45,15.34C390.93,194,391.73,193.29,391.44,191.94Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.44,191.94,384.8,161.1a5.31,5.31,0,0,0-2.83-3.38l-37.45-15.34c-1.28-.52-2.08.15-1.79,1.5,1.31,6.06,5.34,24.77,6.64,30.83a5.29,5.29,0,0,0,2.84,3.39l37.45,15.34C390.93,194,391.73,193.29,391.44,191.94Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,167.31l-1.25-5.77a1,1,0,0,0-.53-.64l-2.57-1.05c-.24-.1-.39,0-.34.28.24,1.14,1,4.64,1.24,5.77a1,1,0,0,0,.53.64l2.58,1.05C383.93,167.68,384.08,167.56,384,167.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.49,162.84a2.47,2.47,0,0,0-1.36-1.56c-.61-.26-1,0-.87.65a2.47,2.47,0,0,0,1.35,1.57C382.23,163.75,382.62,163.46,382.49,162.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.08,165.75a2.52,2.52,0,0,0-1.35-1.57c-.62-.25-1,0-.88.66a2.49,2.49,0,0,0,1.36,1.57C382.82,166.66,383.22,166.37,383.08,165.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,162.07c-1.21-1.9-1.07-2.13-.32-3a5.75,5.75,0,0,1,4.81-2.15c1.6.13,3.23.18,4,.65s0,2.18-2.11,2.54c-3.33.57-3.36,1.46-3.36,1.46s3.07-.51,4.3-.52a30.63,30.63,0,0,1,4.8,1c1.37.29,1.56,2.1-.83,2.59l2.52.54c1.77.38,2.33,1.36.87,2.39a2.61,2.61,0,0,1-1.65.53s1.9.09,1.91.73c0,1.81-1.18,2.23-5.08,3.14-3.72.87-4.58,2.8-3.92,4.2,0,0-1.43-.93-2.7-1.91-.92-.72-1.7-1.51-1.19-3,0,0-2.09-.07-2.15-1.37a6.71,6.71,0,0,1,.65-2.75,2.28,2.28,0,0,1-1-2.21,3.76,3.76,0,0,1,.88-2.23Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.34,164.6a12.4,12.4,0,0,0-2.3-.37,7.49,7.49,0,0,0-2.28.59,28,28,0,0,0-4.15,2,27,27,0,0,0,4.38-1.31,12.28,12.28,0,0,1,2.09-.71C353.77,164.68,354.58,164.71,355.34,164.6Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.08,168.06a5,5,0,0,0-2.5-.21,12.3,12.3,0,0,0-2.42.63,23.16,23.16,0,0,0-4.48,2.1,45.81,45.81,0,0,0,4.7-1.47A13,13,0,0,1,357.08,168.06Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.52,155.11c-3.07-2.61-4.64-3.64-6.11-4.15s-6.61-3-8.6-3.67c-1.27-.4-1.91,1.61-.37,3.11,1.19,1.16,4.37,2.78,5.76,3.65s4,4.47,4,4.47Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.39,141.26c-2.78-7-5.49-9.1-12.7-11.45-7.72,6.65-3.4,25.05-3.4,25.05L446,174s-15.41-5.15-17.51-6.68-7.55-8.18-9.39-10.18c-2.52-2.73-3.86-2.47-5.23-2.35-4.49.39-5.48.7-6.46,1.24a2,2,0,0,0-1,1.68c-1.19.07-3-.07-3.3,1.85a5.58,5.58,0,0,0-.17,1.55,1.32,1.32,0,0,0-.8.39c-1.05,1.08.39,5.12,1.4,6.15.71.72,1.78.87,3.19.77,1.21-.09.73-1.34.73-1.34l1.67.2c3.45,2.79,3.32,7.89,8,9.31a33,33,0,0,1,5.77,1.49c10.07,4.1,23,15.61,32.08,17,8.9,1.33,10.05-3.87,10-9.36C465,177,458.15,148.25,455.39,141.26Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.47,157.75l5.66-.18-5.52-.54A2.09,2.09,0,0,0,406.47,157.75Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,161.15l6.12-.41-6.08-.29A3.14,3.14,0,0,0,403,161.15Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.07,166.26a2.37,2.37,0,0,1-.68-1.21,21.16,21.16,0,0,1-2.11-.27,7.64,7.64,0,0,1-.8-.29,2.42,2.42,0,0,1-.85-.61,2,2,0,0,0,.78.76,3.89,3.89,0,0,0,.89.37l.3.77a1.25,1.25,0,0,0-.65.21,1.61,1.61,0,0,0-.58.76,2.08,2.08,0,0,1,.66-.63,1.27,1.27,0,0,1,.83-.1,2.63,2.63,0,0,1,1.66,1.1l1.67.2A11.45,11.45,0,0,1,408.07,166.26Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M446,174c3.85,1,8.71,5.29,9.65,7.45-1.11-4.72-4-8.66-10.61-10.17Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M442.56,129.51c6.3,1.57,10,3.35,12.51,9.84s7.45,27.42,7.45,27.42-.42,1.27-7.45,2.93-11.59,0-11.59,0-3.72-11.72-5-15.17S434.12,134.66,442.56,129.51Z",
    style: {
      fill: "#00539C"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.87,144.79l1.75-5.47c.95-4.41-17.06,6-18,10.4l5.81,15.62a2.47,2.47,0,0,0,1,1.13c1.28.79,6,3.43,6.38,3.68a2.51,2.51,0,0,0,3.71-1.37L105,143C105.46,140.82,101.31,142.25,96.87,144.79Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.87,144.79l1.75-5.47c.95-4.41-17.06,6-18,10.4l5.81,15.62a2.47,2.47,0,0,0,1,1.13c1.28.79,6,3.43,6.38,3.68a2.51,2.51,0,0,0,3.71-1.37L105,143C105.46,140.82,101.31,142.25,96.87,144.79Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.79,40.7,51.32,80.19a5.15,5.15,0,0,0-2.31,4v81.12a5,5,0,0,0,2.33,4l4.23,2.39a5.16,5.16,0,0,0,4.64,0l68.47-39.49a5.13,5.13,0,0,0,2.31-4V47.06a5,5,0,0,0-2.33-4l-4.23-2.39A5.16,5.16,0,0,0,119.79,40.7Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.79,40.7,51.32,80.19a5.15,5.15,0,0,0-2.31,4v81.12a5,5,0,0,0,2.33,4l4.23,2.39a5.16,5.16,0,0,0,4.64,0l68.47-39.49a5.13,5.13,0,0,0,2.31-4V47.06a5,5,0,0,0-2.33-4l-4.23-2.39A5.16,5.16,0,0,0,119.79,40.7Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.68,45.72,60.21,85.22a5.09,5.09,0,0,0-2.31,4v81.13c0,1.47,1,2.07,2.31,1.33l27.76-16L92.79,169a2.51,2.51,0,0,0,4.69-.23L104,146.43l24.69-14.24a5.13,5.13,0,0,0,2.31-4V47.06C131,45.58,130,45,128.68,45.72Z",
    style: {
      fill: "#00539C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.68,45.72,60.21,85.22a5.09,5.09,0,0,0-2.31,4v81.13c0,1.47,1,2.07,2.31,1.33l27.76-16L92.79,169a2.51,2.51,0,0,0,4.69-.23L104,146.43l24.69-14.24a5.13,5.13,0,0,0,2.31-4V47.06C131,45.58,130,45,128.68,45.72Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,46.64c-.18-1.17-1.13-1.58-2.29-.92L60.22,85.22A4.72,4.72,0,0,0,58.58,87l-8.85-5.11a4.7,4.7,0,0,1,1.6-1.65L119.79,40.7a5.16,5.16,0,0,1,4.64,0l4.23,2.39A5.08,5.08,0,0,1,131,46.64Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.56,92.41l-2.25,1.29V83.93c0-7.25-4.42-10.6-9.86-7.46s-9.87,11.6-9.87,18.85v9.78l-2.24,1.29c-2,1.14-3.57,4.19-3.57,6.8v26.94c0,2.21,1.15,3.46,2.77,3,8.49-2.28,17.32-7.38,25.82-14.91a8.19,8.19,0,0,0,2-2.81,8.56,8.56,0,0,0,.77-3.4V95.1C110.11,92.48,108.52,91.27,106.56,92.41Zm-9,33.35-6.3,3.64,1.1-10c-1.11-.28-1.86-1.48-1.86-3.35,0-2.88,1.75-6.22,3.9-7.47s3.92.08,3.92,3A10,10,0,0,1,96.5,117ZM100.26,96l-11.63,6.72V93c0-4.27,2.61-9.26,5.82-11.11s5.81.12,5.81,4.4Z",
    style: {
      fill: "#fafafa"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignin1);
export default __webpack_public_path__ + "static/media/signin_1.5210c49ec79890a0ce5ea97ec512ba6e.svg";
export { ForwardRef as ReactComponent };